
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire841a"];
var parcelRegister = parcelRequire.register;
parcelRegister("5XPw5", function(module, exports) {

$parcel$export(module.exports, "Integrations", function () { return $457a6c88f0cfb212$export$99d02219d259eb94; });
$parcel$export(module.exports, "Transports", function () { return (parcelRequire("eL2ib")); });

var $eNWiE = parcelRequire("eNWiE");

var $dcsfW = parcelRequire("dcsfW");

var $kU3bm = parcelRequire("kU3bm");

var $jQAuT = parcelRequire("jQAuT");

var $5MV3W = parcelRequire("5MV3W");

var $eL2ib = parcelRequire("eL2ib");
var $457a6c88f0cfb212$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var $457a6c88f0cfb212$var$_window = (0, $jQAuT.getGlobalObject)();
if ($457a6c88f0cfb212$var$_window.Sentry && $457a6c88f0cfb212$var$_window.Sentry.Integrations) $457a6c88f0cfb212$var$windowIntegrations = $457a6c88f0cfb212$var$_window.Sentry.Integrations;
// tslint:enable: no-unsafe-any
var $457a6c88f0cfb212$export$99d02219d259eb94 = $eNWiE.__assign({}, $457a6c88f0cfb212$var$windowIntegrations, (0, $kU3bm), $5MV3W);
$parcel$exportWildcard(module.exports, $dcsfW);

});
parcelRegister("eNWiE", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $ac72dd719767d9e6$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $ac72dd719767d9e6$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spread", function () { return $ac72dd719767d9e6$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ac72dd719767d9e6$var$extendStatics = function(d, b) {
    $ac72dd719767d9e6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ac72dd719767d9e6$var$extendStatics(d, b);
};
function $ac72dd719767d9e6$export$a8ba968b8961cb8a(d, b) {
    $ac72dd719767d9e6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ac72dd719767d9e6$export$18ce0697a983be9b = function() {
    $ac72dd719767d9e6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ac72dd719767d9e6$export$18ce0697a983be9b.apply(this, arguments);
};
function $ac72dd719767d9e6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ac72dd719767d9e6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ac72dd719767d9e6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ac72dd719767d9e6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ac72dd719767d9e6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ac72dd719767d9e6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ac72dd719767d9e6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ac72dd719767d9e6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ac72dd719767d9e6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ac72dd719767d9e6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ac72dd719767d9e6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ac72dd719767d9e6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ac72dd719767d9e6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ac72dd719767d9e6$export$10c90e4f7922046c(v) {
    return this instanceof $ac72dd719767d9e6$export$10c90e4f7922046c ? (this.v = v, this) : new $ac72dd719767d9e6$export$10c90e4f7922046c(v);
}
function $ac72dd719767d9e6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ac72dd719767d9e6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ac72dd719767d9e6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ac72dd719767d9e6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ac72dd719767d9e6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ac72dd719767d9e6$export$19a8beecd37a4c45 === "function" ? $ac72dd719767d9e6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ac72dd719767d9e6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ac72dd719767d9e6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ac72dd719767d9e6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ac72dd719767d9e6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ac72dd719767d9e6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("dcsfW", function(module, exports) {

$parcel$export(module.exports, "Severity", function () { return (parcelRequire("dyq1Y")).Severity; });
$parcel$export(module.exports, "Status", function () { return (parcelRequire("7vcIb")).Status; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return (parcelRequire("cXInE")).addGlobalEventProcessor; });
$parcel$export(module.exports, "addBreadcrumb", function () { return (parcelRequire("326p8")).addBreadcrumb; });
$parcel$export(module.exports, "captureException", function () { return (parcelRequire("326p8")).captureException; });
$parcel$export(module.exports, "captureEvent", function () { return (parcelRequire("326p8")).captureEvent; });
$parcel$export(module.exports, "captureMessage", function () { return (parcelRequire("326p8")).captureMessage; });
$parcel$export(module.exports, "configureScope", function () { return (parcelRequire("326p8")).configureScope; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return (parcelRequire("6kSse")).getHubFromCarrier; });
$parcel$export(module.exports, "getCurrentHub", function () { return (parcelRequire("6kSse")).getCurrentHub; });
$parcel$export(module.exports, "Hub", function () { return (parcelRequire("6kSse")).Hub; });
$parcel$export(module.exports, "makeMain", function () { return (parcelRequire("6kSse")).makeMain; });
$parcel$export(module.exports, "Scope", function () { return (parcelRequire("cXInE")).Scope; });
$parcel$export(module.exports, "startTransaction", function () { return (parcelRequire("326p8")).startTransaction; });
$parcel$export(module.exports, "setContext", function () { return (parcelRequire("326p8")).setContext; });
$parcel$export(module.exports, "setExtra", function () { return (parcelRequire("326p8")).setExtra; });
$parcel$export(module.exports, "setExtras", function () { return (parcelRequire("326p8")).setExtras; });
$parcel$export(module.exports, "setTag", function () { return (parcelRequire("326p8")).setTag; });
$parcel$export(module.exports, "setTags", function () { return (parcelRequire("326p8")).setTags; });
$parcel$export(module.exports, "setUser", function () { return (parcelRequire("326p8")).setUser; });
$parcel$export(module.exports, "withScope", function () { return (parcelRequire("326p8")).withScope; });
$parcel$export(module.exports, "BrowserClient", function () { return (parcelRequire("8hPBK")).BrowserClient; });
$parcel$export(module.exports, "defaultIntegrations", function () { return (parcelRequire("3l402")).defaultIntegrations; });
$parcel$export(module.exports, "forceLoad", function () { return (parcelRequire("3l402")).forceLoad; });
$parcel$export(module.exports, "init", function () { return (parcelRequire("3l402")).init; });
$parcel$export(module.exports, "lastEventId", function () { return (parcelRequire("3l402")).lastEventId; });
$parcel$export(module.exports, "onLoad", function () { return (parcelRequire("3l402")).onLoad; });
$parcel$export(module.exports, "showReportDialog", function () { return (parcelRequire("3l402")).showReportDialog; });
$parcel$export(module.exports, "flush", function () { return (parcelRequire("3l402")).flush; });
$parcel$export(module.exports, "close", function () { return (parcelRequire("3l402")).close; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("3l402")).wrap; });
$parcel$export(module.exports, "SDK_NAME", function () { return (parcelRequire("er0rc")).SDK_NAME; });
$parcel$export(module.exports, "SDK_VERSION", function () { return (parcelRequire("er0rc")).SDK_VERSION; });

var $dyq1Y = parcelRequire("dyq1Y");
var $7vcIb = parcelRequire("7vcIb");

var $326p8 = parcelRequire("326p8");
var $cXInE = parcelRequire("cXInE");
var $6kSse = parcelRequire("6kSse");

var $8hPBK = parcelRequire("8hPBK");

var $3l402 = parcelRequire("3l402");

var $er0rc = parcelRequire("er0rc");

});
parcelRegister("7vcIb", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $576549f17e41fe8c$export$96e9906d6d93a972; });
/** The status of an event. */ var $576549f17e41fe8c$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */ Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */ Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
})($576549f17e41fe8c$export$96e9906d6d93a972 || ($576549f17e41fe8c$export$96e9906d6d93a972 = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function(Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */ function fromHttpCode(code) {
        if (code >= 200 && code < 300) return Status.Success;
        if (code === 429) return Status.RateLimit;
        if (code >= 400 && code < 500) return Status.Invalid;
        if (code >= 500) return Status.Failed;
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})($576549f17e41fe8c$export$96e9906d6d93a972 || ($576549f17e41fe8c$export$96e9906d6d93a972 = {}));

});

parcelRegister("326p8", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $235686cd07738e5d$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $235686cd07738e5d$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $235686cd07738e5d$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $235686cd07738e5d$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $235686cd07738e5d$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $235686cd07738e5d$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtras", function () { return $235686cd07738e5d$export$bb4922da0dd51b92; });
$parcel$export(module.exports, "setTags", function () { return $235686cd07738e5d$export$74a8fb34822092e6; });
$parcel$export(module.exports, "setExtra", function () { return $235686cd07738e5d$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setTag", function () { return $235686cd07738e5d$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $235686cd07738e5d$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $235686cd07738e5d$export$ec58d9285c204497; });
$parcel$export(module.exports, "startTransaction", function () { return $235686cd07738e5d$export$e262da7ae6480481; });

var $9uI1A = parcelRequire("9uI1A");

var $6kSse = parcelRequire("6kSse");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ function $235686cd07738e5d$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $6kSse.getCurrentHub)();
    if (hub && hub[method]) // tslint:disable-next-line:no-unsafe-any
    return hub[method].apply(hub, $9uI1A.__spread(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $235686cd07738e5d$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error("Sentry syntheticException");
    } catch (exception) {
        syntheticException = exception;
    }
    return $235686cd07738e5d$var$callOnHub("captureException", exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $235686cd07738e5d$export$45654777c133ae80(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    } catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arrity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return $235686cd07738e5d$var$callOnHub("captureMessage", message, level, $9uI1A.__assign({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $235686cd07738e5d$export$1462b974fdcf6ba2(event) {
    return $235686cd07738e5d$var$callOnHub("captureEvent", event);
}
function $235686cd07738e5d$export$99d44f04437e9cb8(callback) {
    $235686cd07738e5d$var$callOnHub("configureScope", callback);
}
function $235686cd07738e5d$export$efda9a273d7a036d(breadcrumb) {
    $235686cd07738e5d$var$callOnHub("addBreadcrumb", breadcrumb);
}
function $235686cd07738e5d$export$2f04de43fe27971a(name, context) {
    $235686cd07738e5d$var$callOnHub("setContext", name, context);
}
function $235686cd07738e5d$export$bb4922da0dd51b92(extras) {
    $235686cd07738e5d$var$callOnHub("setExtras", extras);
}
function $235686cd07738e5d$export$74a8fb34822092e6(tags) {
    $235686cd07738e5d$var$callOnHub("setTags", tags);
}
function $235686cd07738e5d$export$8e8e7789d42ed61d(key, extra) {
    $235686cd07738e5d$var$callOnHub("setExtra", key, extra);
}
function $235686cd07738e5d$export$a37d07ee78eb4569(key, value) {
    $235686cd07738e5d$var$callOnHub("setTag", key, value);
}
function $235686cd07738e5d$export$8b6bb3dd62a01be2(user) {
    $235686cd07738e5d$var$callOnHub("setUser", user);
}
function $235686cd07738e5d$export$ec58d9285c204497(callback) {
    $235686cd07738e5d$var$callOnHub("withScope", callback);
}
function $235686cd07738e5d$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $235686cd07738e5d$var$callOnHub.apply(void 0, $9uI1A.__spread([
        "_invokeClient",
        method
    ], args));
}
function $235686cd07738e5d$export$e262da7ae6480481(context) {
    return $235686cd07738e5d$var$callOnHub("startTransaction", $9uI1A.__assign({}, context));
}

});
parcelRegister("9uI1A", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $6e9910c519b84421$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spread", function () { return $6e9910c519b84421$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6e9910c519b84421$var$extendStatics = function(d, b) {
    $6e9910c519b84421$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6e9910c519b84421$var$extendStatics(d, b);
};
function $6e9910c519b84421$export$a8ba968b8961cb8a(d, b) {
    $6e9910c519b84421$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6e9910c519b84421$export$18ce0697a983be9b = function() {
    $6e9910c519b84421$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e9910c519b84421$export$18ce0697a983be9b.apply(this, arguments);
};
function $6e9910c519b84421$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6e9910c519b84421$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6e9910c519b84421$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6e9910c519b84421$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6e9910c519b84421$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6e9910c519b84421$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6e9910c519b84421$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $6e9910c519b84421$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6e9910c519b84421$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6e9910c519b84421$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6e9910c519b84421$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6e9910c519b84421$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6e9910c519b84421$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6e9910c519b84421$export$10c90e4f7922046c(v) {
    return this instanceof $6e9910c519b84421$export$10c90e4f7922046c ? (this.v = v, this) : new $6e9910c519b84421$export$10c90e4f7922046c(v);
}
function $6e9910c519b84421$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6e9910c519b84421$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6e9910c519b84421$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6e9910c519b84421$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6e9910c519b84421$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6e9910c519b84421$export$19a8beecd37a4c45 === "function" ? $6e9910c519b84421$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6e9910c519b84421$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6e9910c519b84421$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6e9910c519b84421$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6e9910c519b84421$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6e9910c519b84421$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("6kSse", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $49ced9dbff52a9aa$export$8c41bb232f1008b1; });
$parcel$export(module.exports, "makeMain", function () { return $49ced9dbff52a9aa$export$4188a14ad302d1bc; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return $49ced9dbff52a9aa$export$bfa8a924a84a76b7; });
$parcel$export(module.exports, "getCurrentHub", function () { return $49ced9dbff52a9aa$export$a07cdf6544bbd7c; });

var $lcHM5 = parcelRequire("lcHM5");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");

var $cXInE = parcelRequire("cXInE");
var $49ced9dbff52a9aa$export$24a86ef7798177e4 = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $49ced9dbff52a9aa$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */ var $49ced9dbff52a9aa$var$MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $49ced9dbff52a9aa$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $cXInE.Scope)();
        if (_version === void 0) _version = $49ced9dbff52a9aa$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [];
        this._stack.push({
            client: client,
            scope: scope
        });
        this.bindClient(client);
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) (_a = top.client)[method].apply(_a, $lcHM5.__spread(args, [
            top.scope
        ]));
    };
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = (0, $cXInE.Scope).clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = (0, $jQAuT.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, $lcHM5.__assign({}, finalHint, {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = (0, $jQAuT.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, $lcHM5.__assign({}, finalHint, {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = this._lastEventId = (0, $jQAuT.uuid4)();
        this._invokeClient("captureEvent", event, $lcHM5.__assign({}, hint, {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) return;
        var _a = top.client.getOptions && top.client.getOptions() || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? $49ced9dbff52a9aa$var$DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $jQAuT.timestampWithMs)();
        var mergedBreadcrumb = $lcHM5.__assign({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $jQAuT.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, $49ced9dbff52a9aa$var$MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setContext = function(name, context) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) callback(top.scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $49ced9dbff52a9aa$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $49ced9dbff52a9aa$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $aDfz0.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context) {
        return this._callExtensionMethod("startTransaction", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $49ced9dbff52a9aa$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        // tslint:disable-next-line: strict-type-predicates
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $aDfz0.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $49ced9dbff52a9aa$export$19eade501500c6c1() {
    var carrier = (0, $jQAuT.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $49ced9dbff52a9aa$export$4188a14ad302d1bc(hub) {
    var registry = $49ced9dbff52a9aa$export$19eade501500c6c1();
    var oldHub = $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry);
    $49ced9dbff52a9aa$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $49ced9dbff52a9aa$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $49ced9dbff52a9aa$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$49ced9dbff52a9aa$var$hasHubOnCarrier(registry) || $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry).isOlderThan($49ced9dbff52a9aa$export$24a86ef7798177e4)) $49ced9dbff52a9aa$export$849f05434e95d2f2(registry, new $49ced9dbff52a9aa$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $jQAuT.isNodeEnv)()) return $49ced9dbff52a9aa$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */ function $49ced9dbff52a9aa$var$getHubFromActiveDomain(registry) {
    try {
        var property = "domain";
        var carrier = $49ced9dbff52a9aa$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        // tslint:disable-next-line: strict-type-predicates
        if (!sentry || !sentry.extensions || !sentry.extensions[property]) return $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry);
        var domain = sentry.extensions[property];
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) return $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!$49ced9dbff52a9aa$var$hasHubOnCarrier(activeDomain) || $49ced9dbff52a9aa$export$bfa8a924a84a76b7(activeDomain).isOlderThan($49ced9dbff52a9aa$export$24a86ef7798177e4)) {
            var registryHubTopStack = $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry).getStackTop();
            $49ced9dbff52a9aa$export$849f05434e95d2f2(activeDomain, new $49ced9dbff52a9aa$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $cXInE.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $49ced9dbff52a9aa$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $49ced9dbff52a9aa$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $49ced9dbff52a9aa$var$hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return true;
    return false;
}
function $49ced9dbff52a9aa$export$bfa8a924a84a76b7(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new $49ced9dbff52a9aa$export$8c41bb232f1008b1();
    return carrier.__SENTRY__.hub;
}
function $49ced9dbff52a9aa$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("lcHM5", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $f6fcacaddeb59aaa$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spread", function () { return $f6fcacaddeb59aaa$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f6fcacaddeb59aaa$var$extendStatics = function(d, b) {
    $f6fcacaddeb59aaa$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f6fcacaddeb59aaa$var$extendStatics(d, b);
};
function $f6fcacaddeb59aaa$export$a8ba968b8961cb8a(d, b) {
    $f6fcacaddeb59aaa$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f6fcacaddeb59aaa$export$18ce0697a983be9b = function() {
    $f6fcacaddeb59aaa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6fcacaddeb59aaa$export$18ce0697a983be9b.apply(this, arguments);
};
function $f6fcacaddeb59aaa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f6fcacaddeb59aaa$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f6fcacaddeb59aaa$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f6fcacaddeb59aaa$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f6fcacaddeb59aaa$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f6fcacaddeb59aaa$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f6fcacaddeb59aaa$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f6fcacaddeb59aaa$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f6fcacaddeb59aaa$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f6fcacaddeb59aaa$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f6fcacaddeb59aaa$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f6fcacaddeb59aaa$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f6fcacaddeb59aaa$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f6fcacaddeb59aaa$export$10c90e4f7922046c(v) {
    return this instanceof $f6fcacaddeb59aaa$export$10c90e4f7922046c ? (this.v = v, this) : new $f6fcacaddeb59aaa$export$10c90e4f7922046c(v);
}
function $f6fcacaddeb59aaa$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f6fcacaddeb59aaa$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f6fcacaddeb59aaa$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f6fcacaddeb59aaa$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f6fcacaddeb59aaa$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f6fcacaddeb59aaa$export$19a8beecd37a4c45 === "function" ? $f6fcacaddeb59aaa$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f6fcacaddeb59aaa$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f6fcacaddeb59aaa$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f6fcacaddeb59aaa$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f6fcacaddeb59aaa$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f6fcacaddeb59aaa$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jQAuT", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "getGlobalObject", function () { return getGlobalObject; }, function (v) { return getGlobalObject = v; });
$parcel$export(module.exports, "uuid4", function () { return uuid4; }, function (v) { return uuid4 = v; });
$parcel$export(module.exports, "parseUrl", function () { return parseUrl; }, function (v) { return parseUrl = v; });
$parcel$export(module.exports, "getEventDescription", function () { return getEventDescription; }, function (v) { return getEventDescription = v; });
$parcel$export(module.exports, "consoleSandbox", function () { return consoleSandbox; }, function (v) { return consoleSandbox = v; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return addExceptionTypeValue; }, function (v) { return addExceptionTypeValue = v; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return addExceptionMechanism; }, function (v) { return addExceptionMechanism = v; });
$parcel$export(module.exports, "getLocationHref", function () { return getLocationHref; }, function (v) { return getLocationHref = v; });
$parcel$export(module.exports, "htmlTreeAsString", function () { return htmlTreeAsString; }, function (v) { return htmlTreeAsString = v; });
$parcel$export(module.exports, "timestampWithMs", function () { return timestampWithMs; }, function (v) { return timestampWithMs = v; });
$parcel$export(module.exports, "parseRetryAfterHeader", function () { return parseRetryAfterHeader; }, function (v) { return parseRetryAfterHeader = v; });
$parcel$export(module.exports, "getFunctionName", function () { return getFunctionName; }, function (v) { return getFunctionName = v; });

var $bcNl8 = parcelRequire("bcNl8");

var $d1Ppj = parcelRequire("d1Ppj");

var $ahJoN = parcelRequire("ahJoN");
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof $ahJoN !== "undefined" ? $ahJoN : 0) === "[object process]";
}
var fallbackGlobalObject = {};
function getGlobalObject() {
    return isNodeEnv() ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : fallbackGlobalObject;
}
function uuid4() {
    var global1 = getGlobalObject();
    var crypto = global1.crypto || global1.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // tslint:disable-next-line:no-bitwise
        var r = Math.random() * 16 | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getEventDescription(event) {
    if (event.message) return event.message;
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) return exception.type + ": " + exception.value;
        return exception.type || exception.value || event.event_id || "<unknown>";
    }
    return event.event_id || "<unknown>";
}
function consoleSandbox(callback) {
    var global1 = getGlobalObject();
    var levels = [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ];
    if (!("console" in global1)) return callback();
    var originalConsole = global1.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function(level) {
        if (level in global1.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function(level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || "";
    event.exception.values[0].type = event.exception.values[0].type || type || "Error";
}
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) mechanism = {};
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore
        // tslint:disable:no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function(key) {
            // @ts-ignore
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    } catch (_oO) {
    // no-empty
    }
}
function getLocationHref() {
    try {
        return document.location.href;
    } catch (oO) {
        return "";
    }
}
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    if (elem.id) out.push("#" + elem.id);
    className = elem.className;
    if (className && (0, $bcNl8.isString)(className)) {
        classes = className.split(/\s+/);
        for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
var INITIAL_TIME = Date.now();
var prevNow = 0;
var performanceFallback = {
    now: function() {
        var now = Date.now() - INITIAL_TIME;
        if (now < prevNow) now = prevNow;
        prevNow = now;
        return now;
    },
    timeOrigin: INITIAL_TIME
};
var crossPlatformPerformance = function() {
    if (isNodeEnv()) try {
        var perfHooks = dynamicRequire(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return performanceFallback;
    }
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) return performanceFallback;
    // Polyfill for performance.timeOrigin.
    //
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // tslint:disable-next-line:strict-type-predicates
    if (performance.timeOrigin === undefined) // As of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always a
    // valid fallback. In the absence of a initial time provided by the browser, fallback to INITIAL_TIME.
    // @ts-ignore
    // tslint:disable-next-line:deprecation
    performance.timeOrigin = performance.timing && performance.timing.navigationStart || INITIAL_TIME;
    return performance;
}();
function timestampWithMs() {
    return (crossPlatformPerformance.timeOrigin + crossPlatformPerformance.now()) / 1000;
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
var defaultRetryAfter = 60000; // 60 seconds
function parseRetryAfterHeader(now, header) {
    if (!header) return defaultRetryAfter;
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return defaultRetryAfter;
}
var defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $d1Ppj.snipLine)(line, 0);
    });
    frame.context_line = (0, $d1Ppj.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $d1Ppj.snipLine)(line, 0);
    });
}

});
parcelRegister("bcNl8", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $82871697801a1209$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $82871697801a1209$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $82871697801a1209$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $82871697801a1209$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $82871697801a1209$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $82871697801a1209$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $82871697801a1209$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $82871697801a1209$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $82871697801a1209$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $82871697801a1209$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $82871697801a1209$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $82871697801a1209$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $82871697801a1209$export$bc2894c7158efbac; });
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $82871697801a1209$export$e6127cc7fe7395c3(wat) {
    switch(Object.prototype.toString.call(wat)){
        case "[object Error]":
            return true;
        case "[object Exception]":
            return true;
        case "[object DOMException]":
            return true;
        default:
            return $82871697801a1209$export$49034edbe6b62415(wat, Error);
    }
}
function $82871697801a1209$export$9f9636d330b71954(wat) {
    return Object.prototype.toString.call(wat) === "[object ErrorEvent]";
}
function $82871697801a1209$export$ef9e2056653f0c8e(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMError]";
}
function $82871697801a1209$export$12e869b2a583f783(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMException]";
}
function $82871697801a1209$export$844ec244b1367d54(wat) {
    return Object.prototype.toString.call(wat) === "[object String]";
}
function $82871697801a1209$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $82871697801a1209$export$53b83ca8eaab0383(wat) {
    return Object.prototype.toString.call(wat) === "[object Object]";
}
function $82871697801a1209$export$9671ea99bd126ace(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Event !== "undefined" && $82871697801a1209$export$49034edbe6b62415(wat, Event);
}
function $82871697801a1209$export$45a5e7f76e0caa8d(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Element !== "undefined" && $82871697801a1209$export$49034edbe6b62415(wat, Element);
}
function $82871697801a1209$export$49841c62b9eff15(wat) {
    return Object.prototype.toString.call(wat) === "[object RegExp]";
}
function $82871697801a1209$export$f5b060c2914b97c8(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === "function");
// tslint:enable:no-unsafe-any
}
function $82871697801a1209$export$bc2894c7158efbac(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return $82871697801a1209$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $82871697801a1209$export$49034edbe6b62415(wat, base) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("d1Ppj", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $97c33eca615fad18$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $97c33eca615fad18$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $97c33eca615fad18$export$465e9d514283d4fd; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $97c33eca615fad18$export$cdded5b28a5f8c6d; });

var $bcNl8 = parcelRequire("bcNl8");
function $97c33eca615fad18$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $97c33eca615fad18$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) return newLine;
    if (colno > ll) colno = ll; // tslint:disable-line:no-parameter-reassignment
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) end = ll;
    if (end === ll) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < ll) newLine += " {snip}";
    return newLine;
}
function $97c33eca615fad18$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $97c33eca615fad18$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $bcNl8.isString)(value)) return false;
    if ((0, $bcNl8.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}

});


parcelRegister("8s5ci", function(module, exports) {
$parcel$export(module.exports, "SentryError", function () { return (parcelRequire("7YoDF")).SentryError; });
$parcel$export(module.exports, "isDOMError", function () { return (parcelRequire("bcNl8")).isDOMError; });
$parcel$export(module.exports, "isDOMException", function () { return (parcelRequire("bcNl8")).isDOMException; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("bcNl8")).isError; });
$parcel$export(module.exports, "isErrorEvent", function () { return (parcelRequire("bcNl8")).isErrorEvent; });
$parcel$export(module.exports, "isEvent", function () { return (parcelRequire("bcNl8")).isEvent; });
$parcel$export(module.exports, "isInstanceOf", function () { return (parcelRequire("bcNl8")).isInstanceOf; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("bcNl8")).isPlainObject; });
$parcel$export(module.exports, "isPrimitive", function () { return (parcelRequire("bcNl8")).isPrimitive; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("bcNl8")).isString; });
$parcel$export(module.exports, "isThenable", function () { return (parcelRequire("bcNl8")).isThenable; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("aDfz0")).logger; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return (parcelRequire("3FEBA")).extractExceptionKeysForMessage; });
$parcel$export(module.exports, "fill", function () { return (parcelRequire("3FEBA")).fill; });
$parcel$export(module.exports, "normalize", function () { return (parcelRequire("3FEBA")).normalize; });
$parcel$export(module.exports, "normalizeToSize", function () { return (parcelRequire("3FEBA")).normalizeToSize; });
$parcel$export(module.exports, "urlEncode", function () { return (parcelRequire("3FEBA")).urlEncode; });
$parcel$export(module.exports, "PromiseBuffer", function () { return (parcelRequire("890oN")).PromiseBuffer; });
$parcel$export(module.exports, "isMatchingPattern", function () { return (parcelRequire("d1Ppj")).isMatchingPattern; });
$parcel$export(module.exports, "safeJoin", function () { return (parcelRequire("d1Ppj")).safeJoin; });
$parcel$export(module.exports, "truncate", function () { return (parcelRequire("d1Ppj")).truncate; });
$parcel$export(module.exports, "supportsFetch", function () { return (parcelRequire("aCc9P")).supportsFetch; });
$parcel$export(module.exports, "supportsReferrerPolicy", function () { return (parcelRequire("aCc9P")).supportsReferrerPolicy; });
$parcel$export(module.exports, "SyncPromise", function () { return (parcelRequire("kBlMe")).SyncPromise; });
$parcel$export(module.exports, "addInstrumentationHandler", function () { return (parcelRequire("9DhZ3")).addInstrumentationHandler; });
$parcel$export(module.exports, "Dsn", function () { return (parcelRequire("lMSBC")).Dsn; });

parcelRequire("7YoDF");
parcelRequire("bcNl8");
parcelRequire("aDfz0");


var $jQAuT = parcelRequire("jQAuT");
parcelRequire("3FEBA");

parcelRequire("890oN");
parcelRequire("d1Ppj");
parcelRequire("aCc9P");
parcelRequire("kBlMe");
parcelRequire("9DhZ3");
parcelRequire("lMSBC");
$parcel$exportWildcard(module.exports, $jQAuT);

});
parcelRegister("7YoDF", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $5ce13fc04b0a91ba$export$5949942ba2a7c0e2; });

var $cPybM = parcelRequire("cPybM");

var $iEsPU = parcelRequire("iEsPU");
/** An error emitted by Sentry SDKs and related utilities. */ var $5ce13fc04b0a91ba$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    $cPybM.__extends(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        (0, $iEsPU.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("cPybM", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $9574c4ac05daf291$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $9574c4ac05daf291$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__values", function () { return $9574c4ac05daf291$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $9574c4ac05daf291$export$8d051b38c9118094; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $9574c4ac05daf291$var$extendStatics = function(d, b) {
    $9574c4ac05daf291$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9574c4ac05daf291$var$extendStatics(d, b);
};
function $9574c4ac05daf291$export$a8ba968b8961cb8a(d, b) {
    $9574c4ac05daf291$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9574c4ac05daf291$export$18ce0697a983be9b = function() {
    $9574c4ac05daf291$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9574c4ac05daf291$export$18ce0697a983be9b.apply(this, arguments);
};
function $9574c4ac05daf291$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9574c4ac05daf291$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9574c4ac05daf291$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9574c4ac05daf291$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9574c4ac05daf291$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9574c4ac05daf291$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $9574c4ac05daf291$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $9574c4ac05daf291$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $9574c4ac05daf291$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9574c4ac05daf291$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9574c4ac05daf291$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9574c4ac05daf291$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9574c4ac05daf291$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9574c4ac05daf291$export$10c90e4f7922046c(v) {
    return this instanceof $9574c4ac05daf291$export$10c90e4f7922046c ? (this.v = v, this) : new $9574c4ac05daf291$export$10c90e4f7922046c(v);
}
function $9574c4ac05daf291$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9574c4ac05daf291$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9574c4ac05daf291$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9574c4ac05daf291$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $9574c4ac05daf291$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9574c4ac05daf291$export$19a8beecd37a4c45 === "function" ? $9574c4ac05daf291$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9574c4ac05daf291$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $9574c4ac05daf291$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $9574c4ac05daf291$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9574c4ac05daf291$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $9574c4ac05daf291$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("iEsPU", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", function () { return $d94254b95a51c3dd$export$1cb0d91350beb6cc; });
var $d94254b95a51c3dd$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $d94254b95a51c3dd$var$setProtoOf : $d94254b95a51c3dd$var$mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */ function $d94254b95a51c3dd$var$setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ function $d94254b95a51c3dd$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!obj.hasOwnProperty(prop)) // @ts-ignore
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("aDfz0", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $7bd99e8074dea181$export$af88d00dbe7f521; });

var $jQAuT = parcelRequire("jQAuT");
// TODO: Implement different loggers for different environments
var $7bd99e8074dea181$var$global = (0, $jQAuT.getGlobalObject)();
/** Prefix for logging strings */ var $7bd99e8074dea181$var$PREFIX = "Sentry Logger ";
/** JSDoc */ var $7bd99e8074dea181$var$Logger = /** @class */ function() {
    /** JSDoc */ function Logger() {
        this._enabled = false;
    }
    /** JSDoc */ Logger.prototype.disable = function() {
        this._enabled = false;
    };
    /** JSDoc */ Logger.prototype.enable = function() {
        this._enabled = true;
    };
    /** JSDoc */ Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $jQAuT.consoleSandbox)(function() {
            $7bd99e8074dea181$var$global.console.log($7bd99e8074dea181$var$PREFIX + "[Log]: " + args.join(" ")); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */ Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $jQAuT.consoleSandbox)(function() {
            $7bd99e8074dea181$var$global.console.warn($7bd99e8074dea181$var$PREFIX + "[Warn]: " + args.join(" ")); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */ Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $jQAuT.consoleSandbox)(function() {
            $7bd99e8074dea181$var$global.console.error($7bd99e8074dea181$var$PREFIX + "[Error]: " + args.join(" ")); // tslint:disable-line:no-console
        });
    };
    return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
$7bd99e8074dea181$var$global.__SENTRY__ = $7bd99e8074dea181$var$global.__SENTRY__ || {};
var $7bd99e8074dea181$export$af88d00dbe7f521 = $7bd99e8074dea181$var$global.__SENTRY__.logger || ($7bd99e8074dea181$var$global.__SENTRY__.logger = new $7bd99e8074dea181$var$Logger());

});

parcelRegister("3FEBA", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $2ac4b2c9cd043cc5$export$9563e054e6f787fb; });
$parcel$export(module.exports, "urlEncode", function () { return $2ac4b2c9cd043cc5$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "normalizeToSize", function () { return $2ac4b2c9cd043cc5$export$23fbbb20bed71033; });
$parcel$export(module.exports, "normalize", function () { return $2ac4b2c9cd043cc5$export$a3295358bff77e; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $2ac4b2c9cd043cc5$export$b0244d5063c0b61b; });

var $cPybM = parcelRequire("cPybM");

var $bcNl8 = parcelRequire("bcNl8");

var $3dFPe = parcelRequire("3dFPe");

var $jQAuT = parcelRequire("jQAuT");

var $d1Ppj = parcelRequire("d1Ppj");
function $2ac4b2c9cd043cc5$export$9563e054e6f787fb(source, name, replacement) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === "function") try {
        wrapped.prototype = wrapped.prototype || {};
        Object.defineProperties(wrapped, {
            __sentry_original__: {
                enumerable: false,
                value: original
            }
        });
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $2ac4b2c9cd043cc5$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(// tslint:disable-next-line:no-unsafe-any
    function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */ function $2ac4b2c9cd043cc5$var$getWalkSource(value) {
    if ((0, $bcNl8.isError)(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack
        };
        for(var i in error)if (Object.prototype.hasOwnProperty.call(error, i)) err[i] = error[i];
        return err;
    }
    if ((0, $bcNl8.isEvent)(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = (0, $bcNl8.isElement)(event_1.target) ? (0, $jQAuT.htmlTreeAsString)(event_1.target) : Object.prototype.toString.call(event_1.target);
        } catch (_oO) {
            source.target = "<unknown>";
        }
        try {
            source.currentTarget = (0, $bcNl8.isElement)(event_1.currentTarget) ? (0, $jQAuT.htmlTreeAsString)(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
        } catch (_oO) {
            source.currentTarget = "<unknown>";
        }
        // tslint:disable-next-line:strict-type-predicates
        if (typeof CustomEvent !== "undefined" && (0, $bcNl8.isInstanceOf)(value, CustomEvent)) source.detail = event_1.detail;
        for(var i in event_1)if (Object.prototype.hasOwnProperty.call(event_1, i)) source[i] = event_1;
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */ function $2ac4b2c9cd043cc5$var$utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $2ac4b2c9cd043cc5$var$jsonSize(value) {
    return $2ac4b2c9cd043cc5$var$utf8Length(JSON.stringify(value));
}
function $2ac4b2c9cd043cc5$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var serialized = $2ac4b2c9cd043cc5$export$a3295358bff77e(object, depth);
    if ($2ac4b2c9cd043cc5$var$jsonSize(serialized) > maxSize) return $2ac4b2c9cd043cc5$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */ function $2ac4b2c9cd043cc5$var$serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === "string") return value;
    if (type === "[object Object]") return "[Object]";
    if (type === "[object Array]") return "[Array]";
    var normalized = $2ac4b2c9cd043cc5$var$normalizeValue(value);
    return (0, $bcNl8.isPrimitive)(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */ // tslint:disable-next-line:cyclomatic-complexity
function $2ac4b2c9cd043cc5$var$normalizeValue(value, key) {
    if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
    if (key === "domainEmitter") return "[DomainEmitter]";
    if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    // React's SyntheticEvent thingy
    if ((0, $bcNl8.isSyntheticEvent)(value)) return "[SyntheticEvent]";
    // tslint:disable-next-line:no-tautology-expression
    if (typeof value === "number" && value !== value) return "[NaN]";
    if (value === void 0) return "[undefined]";
    if (typeof value === "function") return "[Function: " + (0, $jQAuT.getFunctionName)(value) + "]";
    return value;
}
function $2ac4b2c9cd043cc5$export$588732934346abbf(key, value, depth, memo) {
    if (depth === void 0) depth = Infinity;
    if (memo === void 0) memo = new (0, $3dFPe.Memo)();
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) return $2ac4b2c9cd043cc5$var$serializeValue(value);
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === "function") return value.toJSON();
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = $2ac4b2c9cd043cc5$var$normalizeValue(value, key);
    if ((0, $bcNl8.isPrimitive)(normalized)) return normalized;
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = $2ac4b2c9cd043cc5$var$getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) return "[Circular ~]";
    // Walk all keys of the source
    for(var innerKey in source){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) continue;
        // Recursively walk through all the child nodes
        acc[innerKey] = $2ac4b2c9cd043cc5$export$588732934346abbf(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
function $2ac4b2c9cd043cc5$export$a3295358bff77e(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function(key, value) {
            return $2ac4b2c9cd043cc5$export$588732934346abbf(key, value, depth);
        }));
    } catch (_oO) {
        return "**non-serializable**";
    }
}
function $2ac4b2c9cd043cc5$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    // tslint:disable:strict-type-predicates
    var keys = Object.keys($2ac4b2c9cd043cc5$var$getWalkSource(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $d1Ppj.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $d1Ppj.truncate)(serialized, maxLength);
    }
    return "";
}
function $2ac4b2c9cd043cc5$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $bcNl8.isPlainObject)(val)) {
        var obj = val;
        var rv = {};
        try {
            for(var _b = $cPybM.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof obj[key] !== "undefined") rv[key] = $2ac4b2c9cd043cc5$export$d25f2688db1bb433(obj[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($2ac4b2c9cd043cc5$export$d25f2688db1bb433);
    return val;
}

});
parcelRegister("3dFPe", function(module, exports) {

$parcel$export(module.exports, "Memo", function () { return $258307a51e82f331$export$7897aa7841a5380c; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */ var $258307a51e82f331$export$7897aa7841a5380c = /** @class */ function() {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === "function";
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */ Memo.prototype.memoize = function(obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) return true;
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for(var i = 0; i < this._inner.length; i++){
            var value = this._inner[i];
            if (value === obj) return true;
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */ Memo.prototype.unmemoize = function(obj) {
        if (this._hasWeakSet) this._inner.delete(obj);
        else {
            for(var i = 0; i < this._inner.length; i++)if (this._inner[i] === obj) {
                this._inner.splice(i, 1);
                break;
            }
        }
    };
    return Memo;
}();

});


parcelRegister("890oN", function(module, exports) {

$parcel$export(module.exports, "PromiseBuffer", function () { return $5edf793c85616a66$export$9a81892395957e9f; });

var $7YoDF = parcelRequire("7YoDF");

var $kBlMe = parcelRequire("kBlMe");
/** A simple queue that holds promises. */ var $5edf793c85616a66$export$9a81892395957e9f = /** @class */ function() {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */ this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */ PromiseBuffer.prototype.isReady = function() {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */ PromiseBuffer.prototype.add = function(task) {
        var _this = this;
        if (!this.isReady()) return (0, $kBlMe.SyncPromise).reject(new (0, $7YoDF.SentryError)("Not adding Promise due to buffer limit reached."));
        if (this._buffer.indexOf(task) === -1) this._buffer.push(task);
        task.then(function() {
            return _this.remove(task);
        }).then(null, function() {
            return _this.remove(task).then(null, function() {
            // We have to add this catch here otherwise we have an unhandledPromiseRejection
            // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ PromiseBuffer.prototype.remove = function(task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */ PromiseBuffer.prototype.length = function() {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */ PromiseBuffer.prototype.drain = function(timeout) {
        var _this = this;
        return new (0, $kBlMe.SyncPromise)(function(resolve) {
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            (0, $kBlMe.SyncPromise).all(_this._buffer).then(function() {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            }).then(null, function() {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}();

});
parcelRegister("kBlMe", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $eff827c929878a24$export$6f292d4960313241; });

var $bcNl8 = parcelRequire("bcNl8");
/** SyncPromise internal states */ var $eff827c929878a24$var$States;
(function(States) {
    /** Pending */ States["PENDING"] = "PENDING";
    /** Resolved / OK */ States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */ States["REJECTED"] = "REJECTED";
})($eff827c929878a24$var$States || ($eff827c929878a24$var$States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $eff827c929878a24$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = $eff827c929878a24$var$States.PENDING;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult($eff827c929878a24$var$States.RESOLVED, value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult($eff827c929878a24$var$States.REJECTED, reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== $eff827c929878a24$var$States.PENDING) return;
            if ((0, $bcNl8.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */ this._attachHandler = function(handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === $eff827c929878a24$var$States.PENDING) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler.done) return;
                if (_this._state === $eff827c929878a24$var$States.RESOLVED) {
                    if (handler.onfulfilled) handler.onfulfilled(_this._value);
                }
                if (_this._state === $eff827c929878a24$var$States.REJECTED) {
                    if (handler.onrejected) handler.onrejected(_this._value);
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.toString = function() {
        return "[object SyncPromise]";
    };
    /** JSDoc */ SyncPromise.resolve = function(value) {
        return new SyncPromise(function(resolve) {
            resolve(value);
        });
    };
    /** JSDoc */ SyncPromise.reject = function(reason) {
        return new SyncPromise(function(_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */ SyncPromise.all = function(collection) {
        return new SyncPromise(function(resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function(item, index) {
                SyncPromise.resolve(item).then(function(value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) return;
                    resolve(resolvedCollection);
                }).then(null, reject);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function(result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function(reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                }
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("aCc9P", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $7ba6e2371755064d$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $7ba6e2371755064d$export$c82d238e23c40b21; });
$parcel$export(module.exports, "supportsReferrerPolicy", function () { return $7ba6e2371755064d$export$2d308b428295192f; });
$parcel$export(module.exports, "supportsHistory", function () { return $7ba6e2371755064d$export$67fc34576016d6ec; });

var $aDfz0 = parcelRequire("aDfz0");

var $jQAuT = parcelRequire("jQAuT");
function $7ba6e2371755064d$export$caa710b4d7f9cadf() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $7ba6e2371755064d$export$1c08bd1a7eb3c472() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $7ba6e2371755064d$export$ab12a5d056f1d3a() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $7ba6e2371755064d$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $jQAuT.getGlobalObject)())) return false;
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request("");
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ function $7ba6e2371755064d$var$isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $7ba6e2371755064d$export$c82d238e23c40b21() {
    if (!$7ba6e2371755064d$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $jQAuT.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // tslint:disable-next-line:no-unbound-method
    if ($7ba6e2371755064d$var$isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // tslint:disable-next-line:no-unbound-method deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // tslint:disable-next-line:no-unbound-method
        result = $7ba6e2371755064d$var$isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $aDfz0.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $7ba6e2371755064d$export$531055a6c684a70a() {
    // tslint:disable-next-line: no-unsafe-any
    return "ReportingObserver" in (0, $jQAuT.getGlobalObject)();
}
function $7ba6e2371755064d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$7ba6e2371755064d$export$edf3cb81fd7d2a3e()) return false;
    try {
        // tslint:disable:no-unused-expression
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $7ba6e2371755064d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $jQAuT.getGlobalObject)();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("9DhZ3", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", function () { return $7035b4c6a793333d$export$285b9172a3741fb7; });
/* tslint:disable:only-arrow-functions no-unsafe-any */ 
var $cPybM = parcelRequire("cPybM");

var $bcNl8 = parcelRequire("bcNl8");

var $aDfz0 = parcelRequire("aDfz0");

var $jQAuT = parcelRequire("jQAuT");

var $3FEBA = parcelRequire("3FEBA");

var $aCc9P = parcelRequire("aCc9P");
var $7035b4c6a793333d$var$global = (0, $jQAuT.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $7035b4c6a793333d$var$handlers = {};
var $7035b4c6a793333d$var$instrumented = {};
/** Instruments given API */ function $7035b4c6a793333d$var$instrument(type) {
    if ($7035b4c6a793333d$var$instrumented[type]) return;
    $7035b4c6a793333d$var$instrumented[type] = true;
    switch(type){
        case "console":
            $7035b4c6a793333d$var$instrumentConsole();
            break;
        case "dom":
            $7035b4c6a793333d$var$instrumentDOM();
            break;
        case "xhr":
            $7035b4c6a793333d$var$instrumentXHR();
            break;
        case "fetch":
            $7035b4c6a793333d$var$instrumentFetch();
            break;
        case "history":
            $7035b4c6a793333d$var$instrumentHistory();
            break;
        case "error":
            $7035b4c6a793333d$var$instrumentError();
            break;
        case "unhandledrejection":
            $7035b4c6a793333d$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $aDfz0.logger).warn("unknown instrumentation type:", type);
    }
}
function $7035b4c6a793333d$export$285b9172a3741fb7(handler) {
    // tslint:disable-next-line:strict-type-predicates
    if (!handler || typeof handler.type !== "string" || typeof handler.callback !== "function") return;
    $7035b4c6a793333d$var$handlers[handler.type] = $7035b4c6a793333d$var$handlers[handler.type] || [];
    $7035b4c6a793333d$var$handlers[handler.type].push(handler.callback);
    $7035b4c6a793333d$var$instrument(handler.type);
}
/** JSDoc */ function $7035b4c6a793333d$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$7035b4c6a793333d$var$handlers[type]) return;
    try {
        for(var _b = $cPybM.__values($7035b4c6a793333d$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $aDfz0.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $jQAuT.getFunctionName)(handler) + "\nError: " + e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $7035b4c6a793333d$var$instrumentConsole() {
    if (!("console" in $7035b4c6a793333d$var$global)) return;
    [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ].forEach(function(level) {
        if (!(level in $7035b4c6a793333d$var$global.console)) return;
        (0, $3FEBA.fill)($7035b4c6a793333d$var$global.console, level, function(originalConsoleLevel) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $7035b4c6a793333d$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleLevel) Function.prototype.apply.call(originalConsoleLevel, $7035b4c6a793333d$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $7035b4c6a793333d$var$instrumentFetch() {
    if (!(0, $aCc9P.supportsNativeFetch)()) return;
    (0, $3FEBA.fill)($7035b4c6a793333d$var$global, "fetch", function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: $7035b4c6a793333d$var$getFetchMethod(args),
                    url: $7035b4c6a793333d$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $7035b4c6a793333d$var$triggerHandlers("fetch", $cPybM.__assign({}, commonHandlerData));
            return originalFetch.apply($7035b4c6a793333d$var$global, args).then(function(response) {
                $7035b4c6a793333d$var$triggerHandlers("fetch", $cPybM.__assign({}, commonHandlerData, {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $7035b4c6a793333d$var$triggerHandlers("fetch", $cPybM.__assign({}, commonHandlerData, {
                    endTimestamp: Date.now(),
                    error: error
                }));
                throw error;
            });
        };
    });
}
/** Extract `method` from fetch call arguments */ function $7035b4c6a793333d$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ("Request" in $7035b4c6a793333d$var$global && (0, $bcNl8.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $7035b4c6a793333d$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $7035b4c6a793333d$var$global && (0, $bcNl8.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/** JSDoc */ function $7035b4c6a793333d$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $7035b4c6a793333d$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $3FEBA.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var xhr = this; // tslint:disable-line:no-this-assignment
            var url = args[1];
            xhr.__sentry_xhr__ = {
                method: (0, $bcNl8.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            if ((0, $bcNl8.isString)(url) && xhr.__sentry_xhr__.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) xhr.__sentry_xhr__.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $7035b4c6a793333d$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $3FEBA.fill)(xhr, "onreadystatechange", function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $3FEBA.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            $7035b4c6a793333d$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $7035b4c6a793333d$var$lastHref;
/** JSDoc */ function $7035b4c6a793333d$var$instrumentHistory() {
    if (!(0, $aCc9P.supportsHistory)()) return;
    var oldOnPopState = $7035b4c6a793333d$var$global.onpopstate;
    $7035b4c6a793333d$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $7035b4c6a793333d$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $7035b4c6a793333d$var$lastHref;
        $7035b4c6a793333d$var$lastHref = to;
        $7035b4c6a793333d$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) return oldOnPopState.apply(this, args);
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $7035b4c6a793333d$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $7035b4c6a793333d$var$lastHref = to;
                $7035b4c6a793333d$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3FEBA.fill)($7035b4c6a793333d$var$global.history, "pushState", historyReplacementFunction);
    (0, $3FEBA.fill)($7035b4c6a793333d$var$global.history, "replaceState", historyReplacementFunction);
}
/** JSDoc */ function $7035b4c6a793333d$var$instrumentDOM() {
    if (!("document" in $7035b4c6a793333d$var$global)) return;
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    $7035b4c6a793333d$var$global.document.addEventListener("click", $7035b4c6a793333d$var$domEventHandler("click", $7035b4c6a793333d$var$triggerHandlers.bind(null, "dom")), false);
    $7035b4c6a793333d$var$global.document.addEventListener("keypress", $7035b4c6a793333d$var$keypressEventHandler($7035b4c6a793333d$var$triggerHandlers.bind(null, "dom")), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        var proto = $7035b4c6a793333d$var$global[target] && $7035b4c6a793333d$var$global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $3FEBA.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === "click") (0, $3FEBA.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $7035b4c6a793333d$var$domEventHandler("click", $7035b4c6a793333d$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                    if (eventName === "keypress") (0, $3FEBA.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $7035b4c6a793333d$var$keypressEventHandler($7035b4c6a793333d$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                } else {
                    if (eventName === "click") $7035b4c6a793333d$var$domEventHandler("click", $7035b4c6a793333d$var$triggerHandlers.bind(null, "dom"), true)(this);
                    if (eventName === "keypress") $7035b4c6a793333d$var$keypressEventHandler($7035b4c6a793333d$var$triggerHandlers.bind(null, "dom"))(this);
                }
                return original.call(this, eventName, fn, options);
            };
        });
        (0, $3FEBA.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    });
}
var $7035b4c6a793333d$var$debounceDuration = 1000;
var $7035b4c6a793333d$var$debounceTimer = 0;
var $7035b4c6a793333d$var$keypressTimeout;
var $7035b4c6a793333d$var$lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $7035b4c6a793333d$var$domEventHandler(name, handler, debounce) {
    if (debounce === void 0) debounce = false;
    return function(event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        $7035b4c6a793333d$var$keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || $7035b4c6a793333d$var$lastCapturedEvent === event) return;
        $7035b4c6a793333d$var$lastCapturedEvent = event;
        if ($7035b4c6a793333d$var$debounceTimer) clearTimeout($7035b4c6a793333d$var$debounceTimer);
        if (debounce) $7035b4c6a793333d$var$debounceTimer = setTimeout(function() {
            handler({
                event: event,
                name: name
            });
        });
        else handler({
            event: event,
            name: name
        });
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */ function $7035b4c6a793333d$var$keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(event) {
        var target;
        try {
            target = event.target;
        } catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || tagName !== "INPUT" && tagName !== "TEXTAREA" && !target.isContentEditable) return;
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!$7035b4c6a793333d$var$keypressTimeout) $7035b4c6a793333d$var$domEventHandler("input", handler)(event);
        clearTimeout($7035b4c6a793333d$var$keypressTimeout);
        $7035b4c6a793333d$var$keypressTimeout = setTimeout(function() {
            $7035b4c6a793333d$var$keypressTimeout = undefined;
        }, $7035b4c6a793333d$var$debounceDuration);
    };
}
var $7035b4c6a793333d$var$_oldOnErrorHandler = null;
/** JSDoc */ function $7035b4c6a793333d$var$instrumentError() {
    $7035b4c6a793333d$var$_oldOnErrorHandler = $7035b4c6a793333d$var$global.onerror;
    $7035b4c6a793333d$var$global.onerror = function(msg, url, line, column, error) {
        $7035b4c6a793333d$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($7035b4c6a793333d$var$_oldOnErrorHandler) return $7035b4c6a793333d$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $7035b4c6a793333d$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $7035b4c6a793333d$var$instrumentUnhandledRejection() {
    $7035b4c6a793333d$var$_oldOnUnhandledRejectionHandler = $7035b4c6a793333d$var$global.onunhandledrejection;
    $7035b4c6a793333d$var$global.onunhandledrejection = function(e) {
        $7035b4c6a793333d$var$triggerHandlers("unhandledrejection", e);
        if ($7035b4c6a793333d$var$_oldOnUnhandledRejectionHandler) return $7035b4c6a793333d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});

parcelRegister("lMSBC", function(module, exports) {

$parcel$export(module.exports, "Dsn", function () { return $fdc870370bbe3a71$export$aff37ac2a8ccf4dc; });

var $cPybM = parcelRequire("cPybM");

var $7YoDF = parcelRequire("7YoDF");
/** Regular expression used to parse a Dsn. */ var $fdc870370bbe3a71$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */ var $fdc870370bbe3a71$var$ERROR_MESSAGE = "Invalid Dsn";
/** The Sentry Dsn, identifying a Sentry instance and project. */ var $fdc870370bbe3a71$export$aff37ac2a8ccf4dc = /** @class */ function() {
    /** Creates a new Dsn component */ function Dsn(from) {
        if (typeof from === "string") this._fromString(from);
        else this._fromComponents(from);
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */ Dsn.prototype.toString = function(withPassword) {
        if (withPassword === void 0) withPassword = false;
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return protocol + "://" + user + (withPassword && pass ? ":" + pass : "") + ("@" + host + (port ? ":" + port : "") + "/" + (path ? path + "/" : path) + projectId);
    };
    /** Parses a string into this Dsn. */ Dsn.prototype._fromString = function(str) {
        var match = $fdc870370bbe3a71$var$DSN_REGEX.exec(str);
        if (!match) throw new (0, $7YoDF.SentryError)($fdc870370bbe3a71$var$ERROR_MESSAGE);
        var _a = $cPybM.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? "" : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? "" : _c, lastPath = _a[5];
        var path = "";
        var projectId = lastPath;
        var split = projectId.split("/");
        if (split.length > 1) {
            path = split.slice(0, -1).join("/");
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) projectId = projectMatch[0];
        }
        this._fromComponents({
            host: host,
            pass: pass,
            path: path,
            projectId: projectId,
            port: port,
            protocol: protocol,
            user: user
        });
    };
    /** Maps Dsn components into this instance. */ Dsn.prototype._fromComponents = function(components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || "";
        this.host = components.host;
        this.port = components.port || "";
        this.path = components.path || "";
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */ Dsn.prototype._validate = function() {
        var _this = this;
        [
            "protocol",
            "user",
            "host",
            "projectId"
        ].forEach(function(component) {
            if (!_this[component]) throw new (0, $7YoDF.SentryError)($fdc870370bbe3a71$var$ERROR_MESSAGE + ": " + component + " missing");
        });
        if (!this.projectId.match(/^\d+$/)) throw new (0, $7YoDF.SentryError)($fdc870370bbe3a71$var$ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        if (this.protocol !== "http" && this.protocol !== "https") throw new (0, $7YoDF.SentryError)($fdc870370bbe3a71$var$ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        if (this.port && isNaN(parseInt(this.port, 10))) throw new (0, $7YoDF.SentryError)($fdc870370bbe3a71$var$ERROR_MESSAGE + ": Invalid port " + this.port);
    };
    return Dsn;
}();

});


parcelRegister("cXInE", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $96fd6bc7ba0e3e8a$export$775b6bb06e53a214; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $96fd6bc7ba0e3e8a$export$8e4e25f54d456511; });

var $lcHM5 = parcelRequire("lcHM5");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $bcNl8 = parcelRequire("bcNl8");
var $kBlMe = parcelRequire("kBlMe");
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $96fd6bc7ba0e3e8a$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifiying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function() {
                _this._scopeListeners.forEach(function(callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $kBlMe.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor($lcHM5.__assign({}, event), hint);
                if ((0, $bcNl8.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = $lcHM5.__assign({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = $lcHM5.__assign({}, this._tags, (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = $lcHM5.__assign({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = $lcHM5.__assign({}, this._extra, (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        this._contexts = $lcHM5.__assign({}, this._contexts, (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        var span = this.getSpan();
        if (span && span.spanRecorder && span.spanRecorder.spans[0]) return span.spanRecorder.spans[0];
        return undefined;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = $lcHM5.__spread(scope._breadcrumbs);
            newScope._tags = $lcHM5.__assign({}, scope._tags);
            newScope._extra = $lcHM5.__assign({}, scope._extra);
            newScope._contexts = $lcHM5.__assign({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = $lcHM5.__spread(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = $lcHM5.__assign({}, this._tags, captureContext._tags);
            this._extra = $lcHM5.__assign({}, this._extra, captureContext._extra);
            this._contexts = $lcHM5.__assign({}, this._contexts, captureContext._contexts);
            if (captureContext._user) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
        } else if ((0, $bcNl8.isPlainObject)(captureContext)) {
            // tslint:disable-next-line:no-parameter-reassignment
            captureContext;
            this._tags = $lcHM5.__assign({}, this._tags, captureContext.tags);
            this._extra = $lcHM5.__assign({}, this._extra, captureContext.extra);
            this._contexts = $lcHM5.__assign({}, this._contexts, captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = $lcHM5.__assign({
            timestamp: (0, $jQAuT.timestampWithMs)()
        }, breadcrumb);
        this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? $lcHM5.__spread(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxBreadcrumbs) : $lcHM5.__spread(this._breadcrumbs, [
            mergedBreadcrumb
        ]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = $lcHM5.__assign({}, this._extra, event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = $lcHM5.__assign({}, this._tags, event.tags);
        if (this._user && Object.keys(this._user).length) event.user = $lcHM5.__assign({}, this._user, event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = $lcHM5.__assign({}, this._contexts, event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) event.contexts = $lcHM5.__assign({
            trace: this._span.getTraceContext()
        }, event.contexts);
        this._applyFingerprint(event);
        event.breadcrumbs = $lcHM5.__spread(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors($lcHM5.__spread($96fd6bc7ba0e3e8a$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}();
/**
 * Retruns the global event processors.
 */ function $96fd6bc7ba0e3e8a$var$getGlobalEventProcessors() {
    var global = (0, $jQAuT.getGlobalObject)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
function $96fd6bc7ba0e3e8a$export$8e4e25f54d456511(callback) {
    $96fd6bc7ba0e3e8a$var$getGlobalEventProcessors().push(callback);
}

});



parcelRegister("8hPBK", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $6087f186b34371ef$export$1df9218a526d318d; });

var $eNWiE = parcelRequire("eNWiE");

var $gMKo7 = parcelRequire("gMKo7");
var $13u2O = parcelRequire("13u2O");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");

var $03GZG = parcelRequire("03GZG");

var $dtNvR = parcelRequire("dtNvR");

var $er0rc = parcelRequire("er0rc");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $6087f186b34371ef$export$1df9218a526d318d = /** @class */ function(_super) {
    $eNWiE.__extends(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        return _super.call(this, (0, $03GZG.BrowserBackend), options) || this;
    }
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || "javascript";
        event.sdk = $eNWiE.__assign({}, event.sdk, {
            name: (0, $er0rc.SDK_NAME),
            packages: $eNWiE.__spread(event.sdk && event.sdk.packages || [], [
                {
                    name: "npm:@sentry/browser",
                    version: (0, $er0rc.SDK_VERSION)
                }
            ]),
            version: (0, $er0rc.SDK_VERSION)
        });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $dtNvR.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $jQAuT.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $aDfz0.logger).error("Trying to call showReportDialog with Sentry Client is disabled");
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            (0, $aDfz0.logger).error("Missing `eventId` option in showReportDialog call");
            return;
        }
        if (!dsn) {
            (0, $aDfz0.logger).error("Missing `Dsn` option in showReportDialog call");
            return;
        }
        var script = document.createElement("script");
        script.async = true;
        script.src = new (0, $gMKo7.API)(dsn).getReportDialogEndpoint(options);
        if (options.onLoad) script.onload = options.onLoad;
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}((0, $13u2O.BaseClient));

});
parcelRegister("gMKo7", function(module, exports) {

$parcel$export(module.exports, "API", function () { return $c3851cb7796d2f6e$export$2c4e825dc9120f87; });
parcelRequire("8s5ci");
var $lMSBC = parcelRequire("lMSBC");
var $3FEBA = parcelRequire("3FEBA");
var $c3851cb7796d2f6e$var$SENTRY_API_VERSION = "7";
/** Helper class to provide urls to different Sentry endpoints. */ var $c3851cb7796d2f6e$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new (0, $lMSBC.Dsn)(dsn);
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : "";
        var port = dsn.port ? ":" + dsn.port : "";
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : "") + "/api/";
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return this._getIngestEndpoint("store");
    };
    /** Returns the envelope endpoint URL. */ API.prototype._getEnvelopeEndpoint = function() {
        return this._getIngestEndpoint("envelope");
    };
    /** Returns the ingest API endpoint for target. */ API.prototype._getIngestEndpoint = function(target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */ API.prototype._encodedAuth = function() {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: $c3851cb7796d2f6e$var$SENTRY_API_VERSION
        };
        return (0, $3FEBA.urlEncode)(auth);
    };
    /** Returns only the path component for the store endpoint. */ API.prototype.getStoreEndpointPath = function() {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : "") + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */ API.prototype.getRequestHeaders = function(clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = [
            "Sentry sentry_version=" + $c3851cb7796d2f6e$var$SENTRY_API_VERSION
        ];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
        return {
            "Content-Type": "application/json",
            "X-Sentry-Auth": header.join(", ")
        };
    };
    /** Returns the url to the report dialog endpoint. */ API.prototype.getReportDialogEndpoint = function(dialogOptions) {
        if (dialogOptions === void 0) dialogOptions = {};
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for(var key in dialogOptions)if (key === "user") {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
            if (dialogOptions.user.email) encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
        } else encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
        if (encodedOptions.length) return endpoint + "?" + encodedOptions.join("&");
        return endpoint;
    };
    return API;
}();

});

parcelRegister("13u2O", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $0c4d607417be0552$export$4f22f74eddb7716a; });

var $czohF = parcelRequire("czohF");

var $cXInE = parcelRequire("cXInE");
parcelRequire("8s5ci");
var $lMSBC = parcelRequire("lMSBC");
var $bcNl8 = parcelRequire("bcNl8");
var $aDfz0 = parcelRequire("aDfz0");
var $3FEBA = parcelRequire("3FEBA");
var $kBlMe = parcelRequire("kBlMe");
var $d1Ppj = parcelRequire("d1Ppj");
var $jQAuT = parcelRequire("jQAuT");

var $cPgyr = parcelRequire("cPgyr");
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $0c4d607417be0552$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Is the client still processing a call? */ this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = new (0, $lMSBC.Dsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend().eventFromException(exception, hint).then(function(event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = (0, $bcNl8.isPrimitive)(message) ? this._getBackend().eventFromMessage("" + message, level, hint) : this._getBackend().eventFromException(message, hint);
        promisedEvent.then(function(event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope).then(function(finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        }).then(null, function(reason) {
            (0, $aDfz0.logger).error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function(status) {
            clearInterval(status.interval);
            return _this._getBackend().getTransport().close(timeout).then(function(transportFlushed) {
                return status.ready && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled()) this._integrations = (0, $cPgyr.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $aDfz0.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */ BaseClient.prototype._isClientProcessing = function(timeout) {
        var _this = this;
        return new (0, $kBlMe.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function() {
                if (!_this._processing) resolve({
                    interval: interval,
                    ready: true
                });
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) resolve({
                        interval: interval,
                        ready: false
                    });
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = $czohF.__assign({}, event, {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $jQAuT.uuid4)()),
            timestamp: event.timestamp || (0, $jQAuT.timestampWithMs)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $cXInE.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $kBlMe.SyncPromise).resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            // tslint:disable-next-line:strict-type-predicates
            if (typeof normalizeDepth === "number" && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth) {
        if (!event) return null;
        // tslint:disable:no-unsafe-any
        var normalized = $czohF.__assign({}, event, event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return $czohF.__assign({}, b, b.data && {
                    data: (0, $3FEBA.normalize)(b.data, depth)
                });
            })
        }, event.user && {
            user: (0, $3FEBA.normalize)(event.user, depth)
        }, event.contexts && {
            contexts: (0, $3FEBA.normalize)(event.contexts, depth)
        }, event.extra && {
            extra: (0, $3FEBA.normalize)(event.extra, depth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) normalized.contexts.trace = event.contexts.trace;
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        if (event.environment === undefined && environment !== undefined) event.environment = environment;
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $d1Ppj.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $d1Ppj.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $d1Ppj.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) sdkInfo.integrations = integrationsArray;
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) return (0, $kBlMe.SyncPromise).reject("SDK not enabled, will not send event.");
        var isTransaction = event.type === "transaction";
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === "number" && Math.random() > sampleRate) return (0, $kBlMe.SyncPromise).reject("This event has been sampled, will not send event.");
        return new (0, $kBlMe.SyncPromise)(function(resolve, reject) {
            _this._prepareEvent(event, scope, hint).then(function(prepared) {
                if (prepared === null) {
                    reject("An event processor returned null, will not send event.");
                    return;
                }
                var finalEvent = prepared;
                var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                // We skip beforeSend in case of transactions
                if (isInternalException || !beforeSend || isTransaction) {
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                    return;
                }
                var beforeSendResult = beforeSend(prepared, hint);
                // tslint:disable-next-line:strict-type-predicates
                if (typeof beforeSendResult === "undefined") (0, $aDfz0.logger).error("`beforeSend` method has to return `null` or a valid event.");
                else if ((0, $bcNl8.isThenable)(beforeSendResult)) _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                else {
                    finalEvent = beforeSendResult;
                    if (finalEvent === null) {
                        (0, $aDfz0.logger).log("`beforeSend` returned `null`, will not send event.");
                        resolve(null);
                        return;
                    }
                    // From here on we are really async
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                }
            }).then(null, function(reason) {
                _this.captureException(reason, {
                    data: {
                        __sentry__: true
                    },
                    originalException: reason
                });
                reject("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */ BaseClient.prototype._handleAsyncBeforeSend = function(beforeSend, resolve, reject) {
        var _this = this;
        beforeSend.then(function(processedEvent) {
            if (processedEvent === null) {
                reject("`beforeSend` returned `null`, will not send event.");
                return;
            }
            // From here on we are really async
            _this._sendEvent(processedEvent);
            resolve(processedEvent);
        }).then(null, function(e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}();

});
parcelRegister("czohF", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $926b972e9c5a2a91$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spread", function () { return $926b972e9c5a2a91$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $926b972e9c5a2a91$var$extendStatics = function(d, b) {
    $926b972e9c5a2a91$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $926b972e9c5a2a91$var$extendStatics(d, b);
};
function $926b972e9c5a2a91$export$a8ba968b8961cb8a(d, b) {
    $926b972e9c5a2a91$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $926b972e9c5a2a91$export$18ce0697a983be9b = function() {
    $926b972e9c5a2a91$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $926b972e9c5a2a91$export$18ce0697a983be9b.apply(this, arguments);
};
function $926b972e9c5a2a91$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $926b972e9c5a2a91$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $926b972e9c5a2a91$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $926b972e9c5a2a91$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $926b972e9c5a2a91$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $926b972e9c5a2a91$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $926b972e9c5a2a91$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $926b972e9c5a2a91$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $926b972e9c5a2a91$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $926b972e9c5a2a91$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $926b972e9c5a2a91$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($926b972e9c5a2a91$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $926b972e9c5a2a91$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $926b972e9c5a2a91$export$10c90e4f7922046c(v) {
    return this instanceof $926b972e9c5a2a91$export$10c90e4f7922046c ? (this.v = v, this) : new $926b972e9c5a2a91$export$10c90e4f7922046c(v);
}
function $926b972e9c5a2a91$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $926b972e9c5a2a91$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $926b972e9c5a2a91$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $926b972e9c5a2a91$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $926b972e9c5a2a91$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $926b972e9c5a2a91$export$19a8beecd37a4c45 === "function" ? $926b972e9c5a2a91$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $926b972e9c5a2a91$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $926b972e9c5a2a91$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $926b972e9c5a2a91$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $926b972e9c5a2a91$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $926b972e9c5a2a91$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("cPgyr", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", function () { return $956716d6b243d8ea$export$51abed9797baa598; });

var $czohF = parcelRequire("czohF");

var $cXInE = parcelRequire("cXInE");
var $6kSse = parcelRequire("6kSse");
parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");
var $956716d6b243d8ea$export$b14a8888f80a0b3e = [];
function $956716d6b243d8ea$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && $czohF.__spread(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function(i) {
            return i.name;
        });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function(defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 && pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function(userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    } else if (typeof userIntegrations === "function") {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    } else integrations = $czohF.__spread(defaultIntegrations);
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = "Debug";
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, $czohF.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $956716d6b243d8ea$export$e7390a03b70a6f2f(integration) {
    if ($956716d6b243d8ea$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $cXInE.addGlobalEventProcessor), (0, $6kSse.getCurrentHub));
    $956716d6b243d8ea$export$b14a8888f80a0b3e.push(integration.name);
    (0, $aDfz0.logger).log("Integration installed: " + integration.name);
}
function $956716d6b243d8ea$export$51abed9797baa598(options) {
    var integrations = {};
    $956716d6b243d8ea$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $956716d6b243d8ea$export$e7390a03b70a6f2f(integration);
    });
    return integrations;
}

});


parcelRegister("03GZG", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", function () { return $00b1a19c5a0ecec6$export$2526e21aec9d0ce7; });

var $eNWiE = parcelRequire("eNWiE");

var $4rONP = parcelRequire("4rONP");

var $dyq1Y = parcelRequire("dyq1Y");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $aCc9P = parcelRequire("aCc9P");
var $kBlMe = parcelRequire("kBlMe");

var $dmVSh = parcelRequire("dmVSh");

var $ed83F = parcelRequire("ed83F");
var $eOg6B = parcelRequire("eOg6B");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $00b1a19c5a0ecec6$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    $eNWiE.__extends(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = $eNWiE.__assign({}, this._options.transportOptions, {
            dsn: this._options.dsn
        });
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $aCc9P.supportsFetch)()) return new (0, $ed83F.FetchTransport)(transportOptions);
        return new (0, $eOg6B.XHRTransport)(transportOptions);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = (0, $dmVSh.eventFromUnknownInput)(exception, syntheticException, {
            attachStacktrace: this._options.attachStacktrace
        });
        (0, $jQAuT.addExceptionMechanism)(event, {
            handled: true,
            type: "generic"
        });
        event.level = (0, $dyq1Y.Severity).Error;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, $kBlMe.SyncPromise).resolve(event);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $dyq1Y.Severity).Info;
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = (0, $dmVSh.eventFromString)(message, syntheticException, {
            attachStacktrace: this._options.attachStacktrace
        });
        event.level = level;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, $kBlMe.SyncPromise).resolve(event);
    };
    return BrowserBackend;
}((0, $4rONP.BaseBackend));

});
parcelRegister("4rONP", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", function () { return $33d117637b1d5ed9$export$8f43a53a38d7e95f; });
parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");
var $7YoDF = parcelRequire("7YoDF");

var $8mCnf = parcelRequire("8mCnf");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $33d117637b1d5ed9$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $aDfz0.logger).warn("No DSN provided, backend will not do anything.");
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $8mCnf.NoopTransport)();
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $7YoDF.SentryError)("Backend has to implement `eventFromException` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $7YoDF.SentryError)("Backend has to implement `eventFromMessage` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        this._transport.sendEvent(event).then(null, function(reason) {
            (0, $aDfz0.logger).error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    return BaseBackend;
}();

});
parcelRegister("8mCnf", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", function () { return $616e250e524bc290$export$6f2767450ea1346c; });

var $7vcIb = parcelRequire("7vcIb");
parcelRequire("8s5ci");
var $kBlMe = parcelRequire("kBlMe");
/** Noop transport */ var $616e250e524bc290$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $kBlMe.SyncPromise).resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: (0, $7vcIb.Status).Skipped
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $kBlMe.SyncPromise).resolve(true);
    };
    return NoopTransport;
}();

});


parcelRegister("dmVSh", function(module, exports) {

$parcel$export(module.exports, "eventFromUnknownInput", function () { return $9bba391814e403e5$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromString", function () { return $9bba391814e403e5$export$47d86ae4b3c9994; });

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $bcNl8 = parcelRequire("bcNl8");

var $dzday = parcelRequire("dzday");

var $je2N9 = parcelRequire("je2N9");
function $9bba391814e403e5$export$9dd56ed1ef0c3420(exception, syntheticException, options) {
    if (options === void 0) options = {};
    var event;
    if ((0, $bcNl8.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
        event = (0, $dzday.eventFromStacktrace)((0, $je2N9.computeStackTrace)(exception));
        return event;
    }
    if ((0, $bcNl8.isDOMError)(exception) || (0, $bcNl8.isDOMException)(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || ((0, $bcNl8.isDOMError)(domException) ? "DOMError" : "DOMException");
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = $9bba391814e403e5$export$47d86ae4b3c9994(message, syntheticException, options);
        (0, $jQAuT.addExceptionTypeValue)(event, message);
        return event;
    }
    if ((0, $bcNl8.isError)(exception)) {
        // we have a real Error object, do nothing
        event = (0, $dzday.eventFromStacktrace)((0, $je2N9.computeStackTrace)(exception));
        return event;
    }
    if ((0, $bcNl8.isPlainObject)(exception) || (0, $bcNl8.isEvent)(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = (0, $dzday.eventFromPlainObject)(objectException, syntheticException, options.rejection);
        (0, $jQAuT.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $9bba391814e403e5$export$47d86ae4b3c9994(exception, syntheticException, options);
    (0, $jQAuT.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $jQAuT.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $9bba391814e403e5$export$47d86ae4b3c9994(input, syntheticException, options) {
    if (options === void 0) options = {};
    var event = {
        message: input
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = (0, $je2N9.computeStackTrace)(syntheticException);
        var frames_1 = (0, $dzday.prepareFramesForEvent)(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}

});
parcelRegister("dzday", function(module, exports) {

$parcel$export(module.exports, "exceptionFromStacktrace", function () { return $9e08c263ca01ef3a$export$cff07df76f81a017; });
$parcel$export(module.exports, "prepareFramesForEvent", function () { return $9e08c263ca01ef3a$export$37bf8aee02016425; });
$parcel$export(module.exports, "eventFromPlainObject", function () { return $9e08c263ca01ef3a$export$a6a5dd73e489caf; });
$parcel$export(module.exports, "eventFromStacktrace", function () { return $9e08c263ca01ef3a$export$7c1af3e1a12b045e; });
parcelRequire("8s5ci");
var $3FEBA = parcelRequire("3FEBA");
var $bcNl8 = parcelRequire("bcNl8");

var $je2N9 = parcelRequire("je2N9");
var $9e08c263ca01ef3a$var$STACKTRACE_LIMIT = 50;
function $9e08c263ca01ef3a$export$cff07df76f81a017(stacktrace) {
    var frames = $9e08c263ca01ef3a$export$37bf8aee02016425(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message
    };
    if (frames && frames.length) exception.stacktrace = {
        frames: frames
    };
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $9e08c263ca01ef3a$export$a6a5dd73e489caf(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $bcNl8.isEvent)(exception) ? exception.constructor.name : rejection ? "UnhandledRejection" : "Error",
                    value: "Non-Error " + (rejection ? "promise rejection" : "exception") + " captured with keys: " + (0, $3FEBA.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $3FEBA.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var stacktrace = (0, $je2N9.computeStackTrace)(syntheticException);
        var frames_1 = $9e08c263ca01ef3a$export$37bf8aee02016425(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $9e08c263ca01ef3a$export$7c1af3e1a12b045e(stacktrace) {
    var exception = $9e08c263ca01ef3a$export$cff07df76f81a017(stacktrace);
    return {
        exception: {
            values: [
                exception
            ]
        }
    };
}
function $9e08c263ca01ef3a$export$37bf8aee02016425(stack) {
    if (!stack || !stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || "";
    var lastFrameFunction = localStack[localStack.length - 1].func || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $9e08c263ca01ef3a$var$STACKTRACE_LIMIT).map(function(frame) {
        return {
            colno: frame.column === null ? undefined : frame.column,
            filename: frame.url || localStack[0].url,
            function: frame.func || "?",
            in_app: true,
            lineno: frame.line === null ? undefined : frame.line
        };
    }).reverse();
}

});
parcelRegister("je2N9", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", function () { return $dff17d8769d7e5ca$export$81296eded4f2ac09; });
// tslint:disable:object-literal-sort-keys

var $eNWiE = parcelRequire("eNWiE");
// global reference to slice
var $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION = "?";
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $dff17d8769d7e5ca$var$chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $dff17d8769d7e5ca$var$gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var $dff17d8769d7e5ca$var$winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $dff17d8769d7e5ca$var$geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $dff17d8769d7e5ca$var$chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
function $dff17d8769d7e5ca$export$81296eded4f2ac09(ex) {
    // tslint:disable:no-unsafe-any
    var stack = null;
    var popSize = ex && ex.framesToPop;
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = $dff17d8769d7e5ca$var$computeStackTraceFromStacktraceProp(ex);
        if (stack) return $dff17d8769d7e5ca$var$popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    try {
        stack = $dff17d8769d7e5ca$var$computeStackTraceFromStackProp(ex);
        if (stack) return $dff17d8769d7e5ca$var$popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    return {
        message: $dff17d8769d7e5ca$var$extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true
    };
}
/** JSDoc */ // tslint:disable-next-line:cyclomatic-complexity
function $dff17d8769d7e5ca$var$computeStackTraceFromStackProp(ex) {
    // tslint:disable:no-conditional-assignment
    if (!ex || !ex.stack) return null;
    var stack = [];
    var lines = ex.stack.split("\n");
    var isEval;
    var submatch;
    var parts;
    var element;
    for(var i = 0; i < lines.length; ++i){
        if (parts = $dff17d8769d7e5ca$var$chrome.exec(lines[i])) {
            var isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
            isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
            if (isEval && (submatch = $dff17d8769d7e5ca$var$chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf("address at ") === 0 ? parts[2].substr(11) : parts[2],
                func: parts[1] || $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION,
                args: isNative ? [
                    parts[2]
                ] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null
            };
        } else if (parts = $dff17d8769d7e5ca$var$winjs.exec(lines[i])) element = {
            url: parts[2],
            func: parts[1] || $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION,
            args: [],
            line: +parts[3],
            column: parts[4] ? +parts[4] : null
        };
        else if (parts = $dff17d8769d7e5ca$var$gecko.exec(lines[i])) {
            isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
            if (isEval && (submatch = $dff17d8769d7e5ca$var$geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ""; // no column when eval
            } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) // FireFox uses this awesome columnNumber property for its top frame
            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
            // so adding 1
            // NOTE: this hack doesn't work if top-most frame is eval
            stack[0].column = ex.columnNumber + 1;
            element = {
                url: parts[3],
                func: parts[1] || $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(",") : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null
            };
        } else continue;
        if (!element.func && element.line) element.func = $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION;
        stack.push(element);
    }
    if (!stack.length) return null;
    return {
        message: $dff17d8769d7e5ca$var$extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** JSDoc */ function $dff17d8769d7e5ca$var$computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) return null;
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split("\n");
    var stack = [];
    var parts;
    for(var line = 0; line < lines.length; line += 2){
        // tslint:disable:no-conditional-assignment
        var element = null;
        if (parts = opera10Regex.exec(lines[line])) element = {
            url: parts[2],
            func: parts[3],
            args: [],
            line: +parts[1],
            column: null
        };
        else if (parts = opera11Regex.exec(lines[line])) element = {
            url: parts[6],
            func: parts[3] || parts[4],
            args: parts[5] ? parts[5].split(",") : [],
            line: +parts[1],
            column: +parts[2]
        };
        if (element) {
            if (!element.func && element.line) element.func = $dff17d8769d7e5ca$var$UNKNOWN_FUNCTION;
            stack.push(element);
        }
    }
    if (!stack.length) return null;
    return {
        message: $dff17d8769d7e5ca$var$extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** Remove N number of frames from the stack */ function $dff17d8769d7e5ca$var$popFrames(stacktrace, popSize) {
    try {
        return $eNWiE.__assign({}, stacktrace, {
            stack: stacktrace.stack.slice(popSize)
        });
    } catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dff17d8769d7e5ca$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}

});



parcelRegister("ed83F", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", function () { return $a58887bee1bc6c29$export$2bdee3f9b92f4e82; });

var $eNWiE = parcelRequire("eNWiE");

var $k4qrI = parcelRequire("k4qrI");

var $7vcIb = parcelRequire("7vcIb");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");
var $aCc9P = parcelRequire("aCc9P");
var $kBlMe = parcelRequire("kBlMe");

var $j1ZpI = parcelRequire("j1ZpI");
var $a58887bee1bc6c29$var$global = (0, $jQAuT.getGlobalObject)();
/** `fetch` based transport */ var $a58887bee1bc6c29$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    $eNWiE.__extends(FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */ _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */ FetchTransport.prototype.sendEvent = function(event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) return Promise.reject({
            event: event,
            reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
            status: 429
        });
        var sentryReq = (0, $k4qrI.eventToSentryRequest)(event, this._api);
        var options = {
            body: sentryReq.body,
            method: "POST",
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $aCc9P.supportsReferrerPolicy)() ? "origin" : ""
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(new (0, $kBlMe.SyncPromise)(function(resolve, reject) {
            $a58887bee1bc6c29$var$global.fetch(sentryReq.url, options).then(function(response) {
                var status = (0, $7vcIb.Status).fromHttpCode(response.status);
                if (status === (0, $7vcIb.Status).Success) {
                    resolve({
                        status: status
                    });
                    return;
                }
                if (status === (0, $7vcIb.Status).RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + (0, $jQAuT.parseRetryAfterHeader)(now, response.headers.get("Retry-After")));
                    (0, $aDfz0.logger).warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            }).catch(reject);
        }));
    };
    return FetchTransport;
}((0, $j1ZpI.BaseTransport));

});
parcelRegister("k4qrI", function(module, exports) {

$parcel$export(module.exports, "eventToSentryRequest", function () { return $e9c8b200458d2a8d$export$2006389de558b996; });

var $jQAuT = parcelRequire("jQAuT");
function $e9c8b200458d2a8d$export$2006389de558b996(event, api) {
    var useEnvelope = event.type === "transaction";
    var req = {
        body: JSON.stringify(event),
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth()
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            // We need to add * 1000 since we divide it by 1000 by default but JS works with ms precision
            // The reason we use timestampWithMs here is that all clocks across the SDK use the same clock
            sent_at: new Date((0, $jQAuT.timestampWithMs)() * 1000).toISOString()
        });
        var itemHeaders = JSON.stringify({
            type: event.type
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}

});

parcelRegister("j1ZpI", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", function () { return $ddadbfd57f52f4b1$export$74b99d619e90f481; });

var $gMKo7 = parcelRequire("gMKo7");
parcelRequire("8s5ci");
var $890oN = parcelRequire("890oN");
var $7YoDF = parcelRequire("7YoDF");
/** Base Transport class implementation */ var $ddadbfd57f52f4b1$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = new (0, $890oN.PromiseBuffer)(30);
        this._api = new (0, $gMKo7.API)(this.options.dsn);
        // tslint:disable-next-line:deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(_) {
        throw new (0, $7YoDF.SentryError)("Transport Class has to implement `sendEvent` method");
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}();

});


parcelRegister("eOg6B", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", function () { return $ac823a6b0992809e$export$874a283af77e8e62; });

var $eNWiE = parcelRequire("eNWiE");

var $k4qrI = parcelRequire("k4qrI");

var $7vcIb = parcelRequire("7vcIb");
parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");
var $kBlMe = parcelRequire("kBlMe");
var $jQAuT = parcelRequire("jQAuT");

var $j1ZpI = parcelRequire("j1ZpI");
/** `XHR` based transport */ var $ac823a6b0992809e$export$874a283af77e8e62 = /** @class */ function(_super) {
    $eNWiE.__extends(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */ _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */ XHRTransport.prototype.sendEvent = function(event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) return Promise.reject({
            event: event,
            reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
            status: 429
        });
        var sentryReq = (0, $k4qrI.eventToSentryRequest)(event, this._api);
        return this._buffer.add(new (0, $kBlMe.SyncPromise)(function(resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function() {
                if (request.readyState !== 4) return;
                var status = (0, $7vcIb.Status).fromHttpCode(request.status);
                if (status === (0, $7vcIb.Status).Success) {
                    resolve({
                        status: status
                    });
                    return;
                }
                if (status === (0, $7vcIb.Status).RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + (0, $jQAuT.parseRetryAfterHeader)(now, request.getResponseHeader("Retry-After")));
                    (0, $aDfz0.logger).warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open("POST", sentryReq.url);
            for(var header in _this.options.headers)if (_this.options.headers.hasOwnProperty(header)) request.setRequestHeader(header, _this.options.headers[header]);
            request.send(sentryReq.body);
        }));
    };
    return XHRTransport;
}((0, $j1ZpI.BaseTransport));

});


parcelRegister("dtNvR", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $9d046401355d2a19$export$2dc68d50d56fbbd; });

var $eNWiE = parcelRequire("eNWiE");

var $6kSse = parcelRequire("6kSse");

var $dyq1Y = parcelRequire("dyq1Y");
parcelRequire("8s5ci");
var $9DhZ3 = parcelRequire("9DhZ3");
var $d1Ppj = parcelRequire("d1Ppj");
var $jQAuT = parcelRequire("jQAuT");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $9d046401355d2a19$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = $eNWiE.__assign({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $6kSse.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0, $jQAuT.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Creates breadcrumbs from console API calls
     */ Breadcrumbs.prototype._consoleBreadcrumb = function(handlerData) {
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $dyq1Y.Severity).fromString(handlerData.level),
            message: (0, $d1Ppj.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + ((0, $d1Ppj.safeJoin)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6kSse.getCurrentHub)().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */ Breadcrumbs.prototype._domBreadcrumb = function(handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $jQAuT.htmlTreeAsString)(handlerData.event.target) : (0, $jQAuT.htmlTreeAsString)(handlerData.event);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $6kSse.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */ Breadcrumbs.prototype._xhrBreadcrumb = function(handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) return;
            (0, $6kSse.getCurrentHub)().addBreadcrumb({
                category: "xhr",
                data: handlerData.xhr.__sentry_xhr__,
                type: "http"
            }, {
                xhr: handlerData.xhr
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */ Breadcrumbs.prototype._fetchBreadcrumb = function(handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) (0, $6kSse.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: handlerData.fetchData,
            level: (0, $dyq1Y.Severity).Error,
            type: "http"
        }, {
            data: handlerData.error,
            input: handlerData.args
        });
        else (0, $6kSse.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: $eNWiE.__assign({}, handlerData.fetchData, {
                status_code: handlerData.response.status
            }),
            type: "http"
        }, {
            input: handlerData.args,
            response: handlerData.response
        });
    };
    /**
     * Creates breadcrumbs from history API calls
     */ Breadcrumbs.prototype._historyBreadcrumb = function(handlerData) {
        var global = (0, $jQAuT.getGlobalObject)();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, $jQAuT.parseUrl)(global.location.href);
        var parsedFrom = (0, $jQAuT.parseUrl)(from);
        var parsedTo = (0, $jQAuT.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) // tslint:disable-next-line:no-parameter-reassignment
        to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) // tslint:disable-next-line:no-parameter-reassignment
        from = parsedFrom.relative;
        (0, $6kSse.getCurrentHub)().addBreadcrumb({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        var _this = this;
        if (this._options.console) (0, $9DhZ3.addInstrumentationHandler)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._consoleBreadcrumb.apply(_this, $eNWiE.__spread(args));
            },
            type: "console"
        });
        if (this._options.dom) (0, $9DhZ3.addInstrumentationHandler)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._domBreadcrumb.apply(_this, $eNWiE.__spread(args));
            },
            type: "dom"
        });
        if (this._options.xhr) (0, $9DhZ3.addInstrumentationHandler)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._xhrBreadcrumb.apply(_this, $eNWiE.__spread(args));
            },
            type: "xhr"
        });
        if (this._options.fetch) (0, $9DhZ3.addInstrumentationHandler)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._fetchBreadcrumb.apply(_this, $eNWiE.__spread(args));
            },
            type: "fetch"
        });
        if (this._options.history) (0, $9DhZ3.addInstrumentationHandler)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._historyBreadcrumb.apply(_this, $eNWiE.__spread(args));
            },
            type: "history"
        });
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = "Breadcrumbs";
    return Breadcrumbs;
}();

});

parcelRegister("er0rc", function(module, exports) {

$parcel$export(module.exports, "SDK_NAME", function () { return $a823ed3e5f22ac3e$export$ca61d37259221480; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $a823ed3e5f22ac3e$export$31499a9cd224b78c; });
var $a823ed3e5f22ac3e$export$ca61d37259221480 = "sentry.javascript.browser";
var $a823ed3e5f22ac3e$export$31499a9cd224b78c = "5.19.1";

});


parcelRegister("3l402", function(module, exports) {

$parcel$export(module.exports, "defaultIntegrations", function () { return $26e66f7afecb5205$export$5ef831fccfce35e5; });
$parcel$export(module.exports, "init", function () { return $26e66f7afecb5205$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $26e66f7afecb5205$export$3a8fd680da42627b; });
$parcel$export(module.exports, "lastEventId", function () { return $26e66f7afecb5205$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "forceLoad", function () { return $26e66f7afecb5205$export$a3f323d81eede727; });
$parcel$export(module.exports, "onLoad", function () { return $26e66f7afecb5205$export$4e4d8b287d028b6b; });
$parcel$export(module.exports, "flush", function () { return $26e66f7afecb5205$export$4909b86c8034bf73; });
$parcel$export(module.exports, "close", function () { return $26e66f7afecb5205$export$8360e631d277ea4d; });
$parcel$export(module.exports, "wrap", function () { return $26e66f7afecb5205$export$4997ffc0176396a6; });

var $6kSse = parcelRequire("6kSse");
var $4i9sB = parcelRequire("4i9sB");
var $kU3bm = parcelRequire("kU3bm");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $kBlMe = parcelRequire("kBlMe");

var $8hPBK = parcelRequire("8hPBK");

var $fK6pb = parcelRequire("fK6pb");

var $dtNvR = parcelRequire("dtNvR");
var $6kLyJ = parcelRequire("6kLyJ");
var $9EQDg = parcelRequire("9EQDg");
var $59v83 = parcelRequire("59v83");
var $aLABO = parcelRequire("aLABO");
var $26e66f7afecb5205$export$5ef831fccfce35e5 = [
    new (0, $kU3bm).InboundFilters(),
    new (0, $kU3bm).FunctionToString(),
    new (0, $59v83.TryCatch)(),
    new (0, $dtNvR.Breadcrumbs)(),
    new (0, $6kLyJ.GlobalHandlers)(),
    new (0, $9EQDg.LinkedErrors)(),
    new (0, $aLABO.UserAgent)()
];
function $26e66f7afecb5205$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $26e66f7afecb5205$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $jQAuT.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    (0, $4i9sB.initAndBind)((0, $8hPBK.BrowserClient), options);
}
function $26e66f7afecb5205$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    if (!options.eventId) options.eventId = (0, $6kSse.getCurrentHub)().lastEventId();
    var client = (0, $6kSse.getCurrentHub)().getClient();
    if (client) client.showReportDialog(options);
}
function $26e66f7afecb5205$export$5d4e9fd7fac8e617() {
    return (0, $6kSse.getCurrentHub)().lastEventId();
}
function $26e66f7afecb5205$export$a3f323d81eede727() {
// Noop
}
function $26e66f7afecb5205$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $26e66f7afecb5205$export$4909b86c8034bf73(timeout) {
    var client = (0, $6kSse.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    return (0, $kBlMe.SyncPromise).reject(false);
}
function $26e66f7afecb5205$export$8360e631d277ea4d(timeout) {
    var client = (0, $6kSse.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    return (0, $kBlMe.SyncPromise).reject(false);
}
function $26e66f7afecb5205$export$4997ffc0176396a6(fn) {
    return (0, $fK6pb.wrap)(fn)(); // tslint:disable-line:no-unsafe-any
}

});
parcelRegister("4i9sB", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $32002e7f1006b974$export$5333c3f1c58d9bc1; });

var $6kSse = parcelRequire("6kSse");
parcelRequire("8s5ci");
var $aDfz0 = parcelRequire("aDfz0");
function $32002e7f1006b974$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) (0, $aDfz0.logger).enable();
    var hub = (0, $6kSse.getCurrentHub)();
    var client = new clientClass(options);
    hub.bindClient(client);
}

});

parcelRegister("kU3bm", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return (parcelRequire("gQBFJ")).FunctionToString; });
$parcel$export(module.exports, "InboundFilters", function () { return (parcelRequire("3T1OF")).InboundFilters; });

var $gQBFJ = parcelRequire("gQBFJ");

var $3T1OF = parcelRequire("3T1OF");

});
parcelRegister("gQBFJ", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return $c43eb989a3d25049$export$da4704525c20ae79; });
var $c43eb989a3d25049$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $c43eb989a3d25049$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        $c43eb989a3d25049$var$originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = this.__sentry_original__ || this;
            // tslint:disable-next-line:no-unsafe-any
            return $c43eb989a3d25049$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = "FunctionToString";
    return FunctionToString;
}();

});

parcelRegister("3T1OF", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", function () { return $2d47eacdf9992877$export$2ffbb5359dcc6be4; });

var $czohF = parcelRequire("czohF");

var $cXInE = parcelRequire("cXInE");
var $6kSse = parcelRequire("6kSse");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $d1Ppj = parcelRequire("d1Ppj");
var $aDfz0 = parcelRequire("aDfz0");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $2d47eacdf9992877$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $2d47eacdf9992877$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function() {
        (0, $cXInE.addGlobalEventProcessor)(function(event) {
            var hub = (0, $6kSse.getCurrentHub)();
            if (!hub) return event;
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) return null;
            }
            return event;
        });
    };
    /** JSDoc */ InboundFilters.prototype._shouldDropEvent = function(event, options) {
        if (this._isSentryError(event, options)) {
            (0, $aDfz0.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $jQAuT.getEventDescription)(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            (0, $aDfz0.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $jQAuT.getEventDescription)(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            (0, $aDfz0.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $jQAuT.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            (0, $aDfz0.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $jQAuT.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */ InboundFilters.prototype._isSentryError = function(event, options) {
        if (!options.ignoreInternal) return false;
        try {
            return event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].type === "SentryError" || false;
        } catch (_oO) {
            return false;
        }
    };
    /** JSDoc */ InboundFilters.prototype._isIgnoredError = function(event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) return false;
        return this._getPossibleEventMessages(event).some(function(message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function(pattern) {
                return (0, $d1Ppj.isMatchingPattern)(message, pattern);
            });
        });
    };
    /** JSDoc */ InboundFilters.prototype._isDeniedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) return false;
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function(pattern) {
            return (0, $d1Ppj.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._isAllowedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) return true;
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function(pattern) {
            return (0, $d1Ppj.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._mergeOptions = function(clientOptions) {
        if (clientOptions === void 0) clientOptions = {};
        // tslint:disable:deprecation
        return {
            allowUrls: $czohF.__spread(this._options.whitelistUrls || [], this._options.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
            denyUrls: $czohF.__spread(this._options.blacklistUrls || [], this._options.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
            ignoreErrors: $czohF.__spread(this._options.ignoreErrors || [], clientOptions.ignoreErrors || [], $2d47eacdf9992877$var$DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== "undefined" ? this._options.ignoreInternal : true
        };
    };
    /** JSDoc */ InboundFilters.prototype._getPossibleEventMessages = function(event) {
        if (event.message) return [
            event.message
        ];
        if (event.exception) try {
            var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? "" : _b, _c = _a.value, value = _c === void 0 ? "" : _c;
            return [
                "" + value,
                type + ": " + value
            ];
        } catch (oO) {
            (0, $aDfz0.logger).error("Cannot extract message for event " + (0, $jQAuT.getEventDescription)(event));
            return [];
        }
        return [];
    };
    /** JSDoc */ InboundFilters.prototype._getEventFilterUrl = function(event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return frames_1 && frames_1[frames_1.length - 1].filename || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return frames_2 && frames_2[frames_2.length - 1].filename || null;
            }
            return null;
        } catch (oO) {
            (0, $aDfz0.logger).error("Cannot extract url for event " + (0, $jQAuT.getEventDescription)(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = "InboundFilters";
    return InboundFilters;
}();

});


parcelRegister("fK6pb", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $b7601ecdb0b9350a$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $b7601ecdb0b9350a$export$4997ffc0176396a6; });

var $eNWiE = parcelRequire("eNWiE");

var $326p8 = parcelRequire("326p8");

var $jQAuT = parcelRequire("jQAuT");
var $b7601ecdb0b9350a$var$ignoreOnError = 0;
function $b7601ecdb0b9350a$export$b79738ab10c590b2() {
    return $b7601ecdb0b9350a$var$ignoreOnError > 0;
}
function $b7601ecdb0b9350a$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b7601ecdb0b9350a$var$ignoreOnError += 1;
    setTimeout(function() {
        $b7601ecdb0b9350a$var$ignoreOnError -= 1;
    });
}
function $b7601ecdb0b9350a$export$4997ffc0176396a6(fn, options, before) {
    if (options === void 0) options = {};
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== "function") return fn;
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) return fn;
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) return fn.__sentry_wrapped__;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            // tslint:disable-next-line:strict-type-predicates
            if (before && typeof before === "function") before.apply(this, arguments);
            var wrappedArguments = args.map(function(arg) {
                return $b7601ecdb0b9350a$export$4997ffc0176396a6(arg, options);
            });
            if (fn.handleEvent) // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.handleEvent.apply(this, wrappedArguments);
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        // tslint:enable:no-unsafe-any
        } catch (ex) {
            $b7601ecdb0b9350a$export$1265a142ff5ba165();
            (0, $326p8.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    var processedEvent = $eNWiE.__assign({}, event);
                    if (options.mechanism) {
                        (0, $jQAuT.addExceptionTypeValue)(processedEvent, undefined, undefined);
                        (0, $jQAuT.addExceptionMechanism)(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = $eNWiE.__assign({}, processedEvent.extra, {
                        arguments: args
                    });
                    return processedEvent;
                });
                (0, $326p8.captureException)(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, "__sentry_wrapped__", {
        enumerable: false,
        value: sentryWrapped
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true
        },
        __sentry_original__: {
            enumerable: false,
            value: fn
        }
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function() {
                return fn.name;
            }
        });
    } catch (_oO) {
    /*no-empty*/ }
    return sentryWrapped;
}

});

parcelRegister("6kLyJ", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return $49c98099fbd8260e$export$204155decbc90e5a; });

var $eNWiE = parcelRequire("eNWiE");

var $6kSse = parcelRequire("6kSse");

var $dyq1Y = parcelRequire("dyq1Y");

var $jQAuT = parcelRequire("jQAuT");parcelRequire("8s5ci");
var $9DhZ3 = parcelRequire("9DhZ3");
var $bcNl8 = parcelRequire("bcNl8");
var $aDfz0 = parcelRequire("aDfz0");

var $dmVSh = parcelRequire("dmVSh");

var $fK6pb = parcelRequire("fK6pb");
/** Global handlers */ var $49c98099fbd8260e$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /** JSDoc */ this._onErrorHandlerInstalled = false;
        /** JSDoc */ this._onUnhandledRejectionHandlerInstalled = false;
        this._options = $eNWiE.__assign({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            (0, $aDfz0.logger).log("Global Handler attached: onerror");
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            (0, $aDfz0.logger).log("Global Handler attached: onunhandledrejection");
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnErrorHandler = function() {
        var _this = this;
        if (this._onErrorHandlerInstalled) return;
        (0, $9DhZ3.addInstrumentationHandler)({
            callback: function(data) {
                var error = data.error;
                var currentHub = (0, $6kSse.getCurrentHub)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, $fK6pb.shouldIgnoreOnError)() || isFailedOwnDelivery) return;
                var client = currentHub.getClient();
                var event = (0, $bcNl8.isPrimitive)(error) ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column) : _this._enhanceEventWithInitialFrame((0, $dmVSh.eventFromUnknownInput)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: false
                }), data.url, data.line, data.column);
                (0, $jQAuT.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onerror"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
            },
            type: "error"
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function() {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) return;
        (0, $9DhZ3.addInstrumentationHandler)({
            callback: function(e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ("reason" in e) error = e.reason;
                    else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
                } catch (_oO) {
                // no-empty
                }
                var currentHub = (0, $6kSse.getCurrentHub)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, $fK6pb.shouldIgnoreOnError)() || isFailedOwnDelivery) return true;
                var client = currentHub.getClient();
                var event = (0, $bcNl8.isPrimitive)(error) ? _this._eventFromIncompleteRejection(error) : (0, $dmVSh.eventFromUnknownInput)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: true
                });
                event.level = (0, $dyq1Y.Severity).Error;
                (0, $jQAuT.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onunhandledrejection"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
                return;
            },
            type: "unhandledrejection"
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */ GlobalHandlers.prototype._eventFromIncompleteOnError = function(msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = (0, $bcNl8.isErrorEvent)(msg) ? msg.message : msg;
        var name;
        if ((0, $bcNl8.isString)(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || "Error",
                        value: message
                    }
                ]
            }
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */ GlobalHandlers.prototype._eventFromIncompleteRejection = function(error) {
        return {
            exception: {
                values: [
                    {
                        type: "UnhandledRejection",
                        value: "Non-Error promise rejection captured with value: " + error
                    }
                ]
            }
        };
    };
    /** JSDoc */ GlobalHandlers.prototype._enhanceEventWithInitialFrame = function(event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = (0, $bcNl8.isString)(url) && url.length > 0 ? url : (0, $jQAuT.getLocationHref)();
        if (event.exception.values[0].stacktrace.frames.length === 0) event.exception.values[0].stacktrace.frames.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
        return event;
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = "GlobalHandlers";
    return GlobalHandlers;
}();

});

parcelRegister("9EQDg", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", function () { return $7080ad2aacd80790$export$8d1e60aaf616fb4f; });

var $eNWiE = parcelRequire("eNWiE");

var $cXInE = parcelRequire("cXInE");
var $6kSse = parcelRequire("6kSse");
parcelRequire("8s5ci");
var $bcNl8 = parcelRequire("bcNl8");

var $dzday = parcelRequire("dzday");

var $je2N9 = parcelRequire("je2N9");
var $7080ad2aacd80790$var$DEFAULT_KEY = "cause";
var $7080ad2aacd80790$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $7080ad2aacd80790$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $7080ad2aacd80790$var$DEFAULT_KEY;
        this._limit = options.limit || $7080ad2aacd80790$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $cXInE.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $6kSse.getCurrentHub)().getIntegration(LinkedErrors);
            if (self) return self._handler(event, hint);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._handler = function(event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(0, $bcNl8.isInstanceOf)(hint.originalException, Error)) return event;
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = $eNWiE.__spread(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._walkErrorTree = function(error, key, stack) {
        if (stack === void 0) stack = [];
        if (!(0, $bcNl8.isInstanceOf)(error[key], Error) || stack.length + 1 >= this._limit) return stack;
        var stacktrace = (0, $je2N9.computeStackTrace)(error[key]);
        var exception = (0, $dzday.exceptionFromStacktrace)(stacktrace);
        return this._walkErrorTree(error[key], key, $eNWiE.__spread([
            exception
        ], stack));
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = "LinkedErrors";
    return LinkedErrors;
}();

});

parcelRegister("59v83", function(module, exports) {

$parcel$export(module.exports, "TryCatch", function () { return $3c05f08dad0326a0$export$f1a018517668e6d3; });

var $eNWiE = parcelRequire("eNWiE");
parcelRequire("8s5ci");
var $3FEBA = parcelRequire("3FEBA");
var $jQAuT = parcelRequire("jQAuT");

var $fK6pb = parcelRequire("fK6pb");
var $3c05f08dad0326a0$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $3c05f08dad0326a0$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = $eNWiE.__assign({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /** JSDoc */ TryCatch.prototype._wrapTimeFunction = function(original) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var originalCallback = args[0];
            args[0] = (0, $fK6pb.wrap)(originalCallback, {
                mechanism: {
                    data: {
                        function: (0, $jQAuT.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */ TryCatch.prototype._wrapRAF = function(original) {
        return function(callback) {
            return original.call(this, (0, $fK6pb.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $jQAuT.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            }));
        };
    };
    /** JSDoc */ TryCatch.prototype._wrapEventTarget = function(target) {
        var global = (0, $jQAuT.getGlobalObject)();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $3FEBA.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === "function") fn.handleEvent = (0, $fK6pb.wrap)(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: (0, $jQAuT.getFunctionName)(fn),
                                target: target
                            },
                            handled: true,
                            type: "instrument"
                        }
                    });
                } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, (0, $fK6pb.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $jQAuT.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }), options);
            };
        });
        (0, $3FEBA.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function has `__sentry__` property, it means that it was wrapped, and it has additional property
                 * of `__sentry__original__`, holding the handler. And this original handler, has a reversed link,
                 * with `__sentry_wrapped__` property, which holds the wrapped version.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 * In case of second scenario, `__sentry_original__` refers to initial handler, and passed function
                 * is a wrapped version.
                 */ var callback = fn;
                try {
                    if (callback && callback.__sentry__) original.call(this, eventName, callback.__sentry_original__, options);
                } catch (e) {
                // ignore, accessing __sentry__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /** JSDoc */ TryCatch.prototype._wrapXHR = function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var xhr = this; // tslint:disable-line:no-this-assignment
            var xmlHttpRequestProps = [
                "onload",
                "onerror",
                "onprogress",
                "onreadystatechange"
            ];
            xmlHttpRequestProps.forEach(function(prop) {
                if (prop in xhr && typeof xhr[prop] === "function") (0, $3FEBA.fill)(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0, $jQAuT.getFunctionName)(original)
                            },
                            handled: true,
                            type: "instrument"
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    if (original.__sentry_original__) wrapOptions.mechanism.data.handler = (0, $jQAuT.getFunctionName)(original.__sentry_original__);
                    // Otherwise wrap directly
                    return (0, $fK6pb.wrap)(original, wrapOptions);
                });
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $jQAuT.getGlobalObject)();
        if (this._options.setTimeout) (0, $3FEBA.fill)(global, "setTimeout", this._wrapTimeFunction.bind(this));
        if (this._options.setInterval) (0, $3FEBA.fill)(global, "setInterval", this._wrapTimeFunction.bind(this));
        if (this._options.requestAnimationFrame) (0, $3FEBA.fill)(global, "requestAnimationFrame", this._wrapRAF.bind(this));
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in global) (0, $3FEBA.fill)(XMLHttpRequest.prototype, "send", this._wrapXHR.bind(this));
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : $3c05f08dad0326a0$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = "TryCatch";
    return TryCatch;
}();

});

parcelRegister("aLABO", function(module, exports) {

$parcel$export(module.exports, "UserAgent", function () { return $7d6ab0e93ac7ae99$export$5fba5e10934a4faf; });

var $eNWiE = parcelRequire("eNWiE");

var $cXInE = parcelRequire("cXInE");
var $6kSse = parcelRequire("6kSse");

var $jQAuT = parcelRequire("jQAuT");
var $7d6ab0e93ac7ae99$var$global = (0, $jQAuT.getGlobalObject)();
/** UserAgent */ var $7d6ab0e93ac7ae99$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $cXInE.addGlobalEventProcessor)(function(event) {
            if ((0, $6kSse.getCurrentHub)().getIntegration(UserAgent)) {
                if (!$7d6ab0e93ac7ae99$var$global.navigator || !$7d6ab0e93ac7ae99$var$global.location) return event;
                var request = event.request || {};
                request.url = request.url || $7d6ab0e93ac7ae99$var$global.location.href;
                request.headers = request.headers || {};
                request.headers["User-Agent"] = $7d6ab0e93ac7ae99$var$global.navigator.userAgent;
                return $eNWiE.__assign({}, event, {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = "UserAgent";
    return UserAgent;
}();

});



parcelRegister("5MV3W", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return (parcelRequire("6kLyJ")).GlobalHandlers; });
$parcel$export(module.exports, "TryCatch", function () { return (parcelRequire("59v83")).TryCatch; });
$parcel$export(module.exports, "Breadcrumbs", function () { return (parcelRequire("dtNvR")).Breadcrumbs; });
$parcel$export(module.exports, "LinkedErrors", function () { return (parcelRequire("9EQDg")).LinkedErrors; });
$parcel$export(module.exports, "UserAgent", function () { return (parcelRequire("aLABO")).UserAgent; });

var $6kLyJ = parcelRequire("6kLyJ");

var $59v83 = parcelRequire("59v83");

var $dtNvR = parcelRequire("dtNvR");

var $9EQDg = parcelRequire("9EQDg");

var $aLABO = parcelRequire("aLABO");

});

parcelRegister("eL2ib", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", function () { return (parcelRequire("j1ZpI")).BaseTransport; });
$parcel$export(module.exports, "FetchTransport", function () { return (parcelRequire("ed83F")).FetchTransport; });
$parcel$export(module.exports, "XHRTransport", function () { return (parcelRequire("eOg6B")).XHRTransport; });

var $j1ZpI = parcelRequire("j1ZpI");

var $ed83F = parcelRequire("ed83F");

var $eOg6B = parcelRequire("eOg6B");

});



//# sourceMappingURL=esm.5ba79466.js.map
